export const de = {
  navigation: {
    seo: 'SEO',
    sea: 'SEA',
    marketing: 'Marketing',
    ai: 'KI',
    system: 'System',
    dashboard: 'Dashboard',
    seoAudit: 'Website-Audit',
    keywords: 'Keywords',
    serp: 'SERP Monitor',
    backlinks: 'Backlinks',
    competitors: 'Wettbewerber',
    seoSchedules: 'Zeitpläne',
    campaigns: 'Kampagnen',
    adPerformance: 'Anzeigenleistung',
    contentGenerator: 'Content Generator',
    automation: 'Automatisierung',
    reports: 'Berichte',
    aiAdvisor: 'KI-Berater',
    settings: 'Einstellungen',
    profile: 'Profil',
    logs: 'Protokolle',
    logout: 'Abmelden',
    projects: 'Projekte',
    globalAI: 'Globale KI',
    selectProject: 'Projekt auswählen',
    home: 'Startseite',
    roadmap: 'Roadmap',
    templates: 'Vorlagen',
    integrations: 'Integrationen',
    admin: 'Admin',
    seoDashboard: 'SEO Dashboard',
    adsDashboard: 'Ads Dashboard',
    seoCrawls: 'Crawls',
    seaCampaigns: 'Kampagnen',
    performance: 'Performance',
    shoppingCampaigns: 'Shopping-Kampagnen',
    conversions: 'Conversions',
    audiences: 'Zielgruppen',
    recommendations: 'Empfehlungen',
    negativeKeywords: 'Negative Keywords',
    searchTerms: 'Suchbegriffe',
    auctionInsights: 'Auktions-Statistiken',
    products: 'Produkte',
    bidRules: 'Gebotsregeln',
    metaAds: 'Meta Ads',
    tiktokAds: 'TikTok Ads',
    // SEO navigation groups
    groupAuditsCrawl: 'Audits & Crawl',
    groupKeywords: 'Keywords',
    groupContent: 'Content',
    groupOffPage: 'Off-Page',
    groupAiPerformance: 'KI & Performance',
    keywordMapping: 'Keyword-Mapping',
    keywordResearch: 'Keyword-Recherche',
    contentOptimization: 'Content-Optimierung',
    migration: 'Migration / Vergleich',
    geo: 'GEO',
    seoTasks: 'Smart To-Do',
    visualAnalysis: 'Visuelle Analyse',
    irysIndex: 'Irys SEO Index',
  },
  dashboard: {
    title: 'Dashboard',
    welcome: 'Willkommen zurück',
    overview: 'Übersicht',
    seoScore: 'SEO Score',
    organicTraffic: 'Organischer Traffic',
    keywordsTracked: 'Verfolgte Keywords',
    backlinksTotal: 'Backlinks gesamt',
    activeCampaigns: 'Aktive Kampagnen',
    adSpend: 'Werbeausgaben',
    recentActivity: 'Letzte Aktivitäten',
    quickActions: 'Schnellaktionen',
    totalProjects: 'Projekte gesamt',
    trackedKeywords: 'Verfolgte Keywords',
    backlinks: 'Backlinks',
    avgPosition: 'Durchschn. Position',
    noRecentActivity: 'Keine aktuellen Aktivitäten vorhanden.',
    seoOverview: 'SEO-Übersicht',
    campaignOverview: 'Kampagnen-Übersicht',
    automationOverview: 'Automatisierungs-Übersicht',
  },
  seo: {
    selectProject: 'Wählen Sie ein Projekt aus, um SEO-Daten anzuzeigen.',
    dashboard: {
      title: 'SEO Dashboard',
      noData: 'Noch keine Crawl-Daten',
      loadError: 'Dashboard-Daten konnten nicht geladen werden',
      noDataDesc: 'Starten Sie Ihren ersten Crawl, um die SEO-Performance über die Zeit zu verfolgen.',
      runFirstCrawl: 'Ersten Crawl starten',
      crawls: 'Crawls',
      viewCrawls: 'Crawls anzeigen',
      currentScore: 'Aktueller Score',
      keywordsTracked: 'Keywords verfolgt',
      pagesTracked: 'Seiten verfolgt',
      lastCrawl: 'Letzter Crawl',
      scoreTrend: 'Score-Verlauf',
      overall: 'Gesamt',
      titleScore: 'Titel',
      metaScore: 'Meta',
      contentScore: 'Inhalt',
      technicalScore: 'Technik',
      issueTrend: 'Fehler-Verlauf',
      critical: 'Kritisch',
      warnings: 'Warnungen',
      info: 'Info',
      keywordTrends: 'Keyword-Trends',
      keyword: 'Keyword',
      page: 'Seite',
      position: 'Position',
      change: 'Änderung',
      clicks: 'Klicks',
      impressions: 'Impressionen',
    },
    audit: {
      title: 'Website-Audit',
      newAudit: 'Neues Audit',
      runAudit: 'Audit starten',
      score: 'SEO Score',
      issues: 'Gefundene Probleme',
      pagesCrawled: 'Gecrawlte Seiten',
      critical: 'Kritisch',
      warnings: 'Warnungen',
      passed: 'Bestanden',
      lastAudit: 'Letztes Audit',
      noAudits: 'Noch keine Audits vorhanden. Starten Sie Ihr erstes Audit, um Ergebnisse zu sehen.',
      startAudit: 'Audit starten',
      emptyTitle: 'Noch keine Audits',
      emptyDesc: 'Starten Sie Ihr erstes SEO-Audit, um Ergebnisse zu sehen',
      startAuditTitle: 'Neuen Audit starten',
      startAuditDesc: 'Wir crawlen Ihre Website und analysieren jede Seite auf SEO-Probleme, Performance und Inhaltsqualität. Dies kann je nach Größe Ihrer Website einige Minuten dauern.',
      editAuditTitle: 'Crawl-Einstellungen bearbeiten',
      editAuditDesc: 'Aktualisieren Sie die Crawl-Konfiguration. Änderungen gelten für diesen Crawl, sofern er noch nicht gelaufen ist, oder dienen als Vorlage für den nächsten Crawl dieser Domain.',
      editSettings: 'Einstellungen bearbeiten',
      auditTypeLabel: 'Audit-Typ',
      auditTypeFull: 'Vollständiger Audit',
      auditTypeTechnical: 'Nur Technik',
      auditTypeContent: 'Nur Inhalt',
      configLabel: 'Crawl-Einstellungen',
      maxPagesLabel: 'Max. Seiten',
      maxPagesUnlimited: 'Unbegrenzt',
      maxDepthLabel: 'Max. Tiefe',
      maxDepthUnlimited: 'Unbegrenzt',
      jsRenderingLabel: 'JavaScript-Rendering',
      jsRenderingHint: 'Für React/Angular/Vue-Seiten aktivieren (langsamer)',
      includeSubdomainsLabel: 'Subdomains einschließen',
      includeGscLabel: 'Google Search Console Daten einbeziehen',
      includeGscHint: 'Crawl-Ergebnisse mit GSC-Impressionen, Klicks & Positionen anreichern',
      crawlCompetitorsLabel: 'Auch Wettbewerber crawlen',
      crawlCompetitorsHint: 'Startet einen separaten Audit für jeden konfigurierten Wettbewerber',
      advancedFeatures: 'Erweiterte Funktionen (opt-in)',
      includeGa4Label: 'Google Analytics 4',
      includeGa4Hint: 'Seiten-Engagement-Daten abrufen (Aufrufe, Absprungrate, Sitzungen)',
      includeGa4NotConnected: '⚠ GA4 ist für dieses Projekt nicht verbunden — Daten werden nicht abgerufen.',
      includeCwvLabel: 'Core Web Vitals',
      includeCwvHint: 'LCP, CLS, FCP während des Crawls messen (benötigt JS-Rendering)',
      includeSchemaValidationLabel: 'Schema-Validierung',
      includeSchemaValidationHint: 'Strukturierte Daten gegen schema.org prüfen',
      includeMobileCheckLabel: 'Mobil-Check',
      includeMobileCheckHint: 'Viewport-Meta-Tag und Mobile-Kompatibilität prüfen',
      includeAiOverviewLabel: 'AI Overview Tracking',
      includeAiOverviewHint: 'Prüfen, ob Ihre Domain in Google AI Overviews erscheint (via DataForSEO)',
      includeAiAnalysisLabel: 'AI-gestützte Analyse',
      includeAiAnalysisHint: 'Erweiterte KI-Vorschläge (⚠ teuer für große Shops — vorher bestätigen)',
      startButton: 'Audit starten',
      cancelButton: 'Abbrechen',
      cancelAudit: 'Audit abbrechen',
      cancelAuditConfirm: 'Diesen Audit stoppen?',
      statusPending: 'Ausstehend',
      statusCrawling: 'Crawling',
      statusAnalyzing: 'Analysiere',
      statusScoring: 'Bewertung',
      statusCompleted: 'Abgeschlossen',
      statusFailed: 'Fehlgeschlagen',
      progressLabel: 'Fortschritt',
      pagesProgress: '{crawled} / {total} Seiten',
      schedulesTitle: 'Geplante Audits',
      noSchedules: 'Noch keine geplanten Audits.',
      addSchedule: 'Zeitplan hinzufügen',
      editSchedule: 'Zeitplan bearbeiten',
      deleteSchedule: 'Zeitplan löschen',
      scheduleFrequency: 'Häufigkeit',
      scheduleDaily: 'Täglich',
      scheduleWeekly: 'Wöchentlich',
      scheduleMonthly: 'Monatlich',
      scheduleDayOfWeek: 'Wochentag',
      scheduleTime: 'Uhrzeit',
      scheduleNextRun: 'Nächster Lauf',
      scheduleLastRun: 'Letzter Lauf',
      scheduleActive: 'Aktiv',
      scheduleInactive: 'Inaktiv',
      scheduleToggle: 'Aktiv umschalten',
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
      deleteScheduleConfirm: 'Diesen Zeitplan löschen?',
      targetDomainLabel: 'Zu crawlende Domain',
      targetDomainProject: 'Eigene Website',
      targetDomainCompetitor: 'Wettbewerber',
      deleteAudit: 'Audit löschen',
      deleteAuditConfirmDesc: 'Dieses Audit und alle zugehörigen Daten werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
      cancelAuditConfirmDesc: 'Der laufende Crawl wird gestoppt. Bereits gecrawlte Seiten bleiben erhalten, aber das Audit wird als fehlgeschlagen markiert.',
      confirmStop: 'Audit stoppen',
      confirmDelete: 'Löschen',
      convertToSchedule: 'In Zeitplan umwandeln',
      triggerNow: 'Jetzt ausführen',
      deleteScheduleConfirmDesc: 'Dieser geplante Audit wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    auditDetail: {
      title: 'Audit-Details',
      notFound: 'Audit nicht gefunden.',
      overall: 'Gesamt',
      titleScore: 'Titel',
      metaScore: 'Meta',
      contentScore: 'Inhalt',
      technicalScore: 'Technik',
      headingScore: 'Überschriften',
      imageScore: 'Bilder',
      linkScore: 'Links',
      schemaScore: 'Schema',
      statusCode: 'Status',
      loadTime: 'Ladezeit',
      metaDescription: 'Meta-Beschreibung',
      canonical: 'Canonical',
      internalLinks: 'Interne Links',
      externalLinks: 'Externe Links',
      brokenLinks: 'Fehlerhafte Links',
      links: 'Links',
      issues: 'Probleme',
      totalIssues: 'Gesamtprobleme',
      issueTypes: 'Problemtypen',
      overviewTab: 'Übersicht',
      pagesTab: 'Seiten',
      issuesTab: 'Probleme',
      noPages: 'Keine Seitenergebnisse gefunden.',
      noIssues: 'Keine Probleme gefunden — super!',
      page: 'Seite',
      duration: 'Dauer',
      scoreOverview: 'Score-Übersicht',
      critical: 'Kritisch',
      warning: 'Warnung',
      info: 'Info',
      avgLoadTime: 'Durchschn. Ladezeit',
      avgTTFB: 'Durchschn. TTFB',
      avgPageSize: 'Durchschn. Seitengröße',
      maxLoadTime: 'Max. Ladezeit',
      indexable: 'Indexierbar',
      notIndexable: 'Nicht indexierbar',
      redirects: 'Weiterleitungen',
      redirect: 'Weiterleitung',
      inSitemap: 'In Sitemap',
      hasSchema: 'Hat Schema',
      hasOpenGraph: 'Hat Open Graph',
      crawlOverview: 'Crawl-Übersicht',
      performance: 'Performance',
      issueSeverity: 'Problemschwere',
      issuesByCategory: 'Probleme nach Kategorie',
      topIssues: 'Top-Probleme',
      scoreDistribution: 'Score-Verteilung',
      statusCodes: 'Statuscodes',
      searchPages: 'Seiten durchsuchen...',
      pageSize: 'Seitengröße',
      wordCount: 'Wortanzahl',
      textRatio: 'Textverhältnis',
      seoMeta: 'SEO-Meta',
      technicalDetails: 'Technische Details',
      crawlDepth: 'Crawl-Tiefe',
      affectedPages: 'Betroffene Seiten',
      presets: 'Vorlagen',
      clearFilters: 'Zurücksetzen',
      presetNamePlaceholder: 'Name der Filtervorlage...',
      all: 'Alle',
      withIssues: 'Mit Problemen',
      noRedirect: 'Keine Weiterleitung',
      keywordsTab: 'Keywords',
      historyTab: 'Verlauf',
      engagementTab: 'Engagement',
      aiOverviewTab: 'AI-Übersicht',
      siteStructureTab: 'Seitenstruktur',
      technicalTab: 'Technik',
      gscSummary: 'Search Console Zusammenfassung',
      gscTotalClicks: 'Klicks gesamt',
      gscTotalImpressions: 'Impressionen gesamt',
      gscAvgPosition: 'Durchschn. Position',
      gscAvgCtr: 'Durchschn. CTR',
      gscPagesWithData: 'Seiten mit GSC-Daten',
      gscTopPages: 'Top-Seiten nach Klicks',
      gscTopKeywords: 'Top-Keywords',
      gscNoData: 'Keine Google Search Console Daten für dieses Audit verfügbar.',
      gscNoDataWdf: 'Keine Google Search Console Daten für dieses Audit — zeige im Crawl erkannte Keywords (WDF*IDF).',
      wdfIdfKeywords: 'Im Crawl erkannte Keywords (WDF*IDF)',
      wdfIdfScore: 'WDF*IDF',
      pagesFound: 'Seiten',
      searchVolume: 'Volumen',
      cannibalization: 'Keyword-Kannibalisierung',
      loadCannib: 'Laden',
      viewPages: 'Seiten anzeigen',
      noCannib: 'Keine Kannibalisierung erkannt',
      gscPageUrl: 'Seiten-URL',
      gscKeyword: 'Keyword',
      gscKeywordsTotal: 'Keywords gesamt',
      gscClicks: 'Klicks',
      gscImpressions: 'Impressionen',
      gscCtr: 'CTR',
      gscPosition: 'Position',
      historyTitle: 'Audit-Verlauf',
      historyNoData: 'Keine vorherigen Audits für diese Domain gefunden.',
      historyScoreTrend: 'Score-Verlauf',
      historyIssueTrend: 'Problem-Verlauf',
      historyDate: 'Datum',
      historyScore: 'Score',
      historyPages: 'Seiten',
      historyIssues: 'Probleme',
      historyView: 'Ansehen',
      // AI Overview
      aiOverviewTitle: 'AI-Übersicht-Sichtbarkeit',
      aiOverviewDescription: 'Verfolgen Sie, ob Ihre Domain in den Google AI-Übersicht-Ergebnissen für Ihre Keywords erscheint.',
      aiOverviewCheckNow: 'Jetzt prüfen',
      aiOverviewKeywordsChecked: 'Keywords geprüft',
      aiOverviewPresent: 'AI-Übersicht vorhanden',
      aiOverviewDomainCited: 'Domain zitiert',
      aiOverviewCitationRate: 'Zitationsrate',
      aiOverviewCitedOnly: 'Nur zitiert',
      aiOverviewResults: 'Ergebnisse',
      aiOverviewKeyword: 'Keyword',
      aiOverviewStatus: 'AI-Übersicht',
      aiOverviewCited: 'Zitiert',
      aiOverviewReferences: 'Referenzen',
      aiOverviewCheckedAt: 'Geprüft',
      aiOverviewActive: 'Vorhanden',
      aiOverviewNone: 'Keine',
      aiOverviewYes: 'Ja',
      aiOverviewNo: 'Nein',
      aiOverviewNoResults: 'Noch keine AI-Übersicht-Daten. Klicken Sie auf "Jetzt prüfen".',
      aiOverviewNoCitedResults: 'Keine Ergebnisse, in denen Ihre Domain zitiert wird.',
      aiOverviewEmpty: 'Keine AI-Übersicht-Daten',
      aiOverviewEmptyDescription: 'Prüfen Sie, ob Ihre Domain in Google AI-Übersicht-Ergebnissen erscheint.',
      aiOverviewRunFirst: 'Erste Prüfung starten',
      aiOverviewDataForSEONote: 'Powered by DataForSEO — prüft getrackte Keywords auf AI Overview-Präsenz.',
      // Engagement (GA4)
      engagementTitle: 'Seiten-Engagement',
      engagementDescription: 'Nutzerengagement-Metriken von Google Analytics 4 für gecrawlte Seiten.',
      engagementAvgDuration: 'Durchschn. Sitzungsdauer',
      engagementRate: 'Engagement-Rate',
      engagementPageViews: 'Seitenaufrufe',
      engagementActiveUsers: 'Aktive Nutzer',
      engagementByPage: 'Engagement nach Seite',
      engagementPage: 'Seite',
      engagementViews: 'Aufrufe',
      engagementEngRate: 'Eng.-Rate',
      engagementBounce: 'Absprung',
      engagementDuration: 'Dauer',
      engagementUsers: 'Nutzer',
      engagementSessions: 'Sitzungen',
      engagementEmpty: 'Keine Engagement-Daten',
      engagementEmptyDescription: 'Verbinden Sie Google Analytics und aktivieren Sie GA4 in den Crawl-Einstellungen.',
      engagementHowToEnable: 'Aktivieren Sie "Google Analytics 4" in den erweiterten Funktionen beim Start eines neuen Audits.',
      // Crawl health
      crawlHealth: 'Crawl-Gesundheit',
      contentAnalysis: 'Inhaltsanalyse',
      metaKeywords: 'Meta-Keywords',
      bodyTextPreview: 'Textvorschau',
      keywordAnalysis: 'WDF*IDF-Keyword-Analyse',
      loadingKeywords: 'Keyword-Analyse wird geladen...',
      noKeywords: 'Keine Keyword-Daten verfügbar. Starten Sie ein neues Audit, um WDF*IDF-Scores zu generieren.',
      keyword: 'Keyword',
      cwvTitle: 'Core Web Vitals',
      cwvNoData: 'Keine CWV-Daten — JavaScript-Rendering in Crawl-Einstellungen aktivieren',
      lcp: 'LCP',
      lcpDesc: 'Largest Contentful Paint',
      cls: 'CLS',
      clsDesc: 'Cumulative Layout Shift',
      fcp: 'FCP',
      fcpDesc: 'First Contentful Paint',
      ttfb: 'TTFB',
      ttfbDesc: 'Time to First Byte',
      cwvGood: 'Gut',
      cwvNeedsImprovement: 'Verbesserungsbedürftig',
      cwvPoor: 'Schlecht',
      aiAnalysis: 'KI-Analyse',
      analyzeWithAi: 'Mit KI analysieren',
      suggestMeta: 'Meta-Tags vorschlagen',
      getRecommendations: 'SEO-Empfehlungen abrufen',
      analyzing: 'Wird analysiert...',
      suggestedTitles: 'Vorgeschlagene Titel',
      suggestedDescriptions: 'Vorgeschlagene Beschreibungen',
      copied: 'In Zwischenablage kopiert',
      charCount: 'Zeichen',
      contentScoreAi: 'Inhalts-Score',
      strengths: 'Stärken',
      weaknesses: 'Verbesserungspotenzial',
      suggestions: 'Vorschläge',
      aiUnavailable: 'KI-Analyse nicht verfügbar',
      copyToClipboard: 'Kopieren',
      readability: 'Lesbarkeit',
      keywordDensity: 'Keyword-Dichte',
      impact: 'Auswirkung',
      effort: 'Aufwand',
      priority: 'Priorität',
    },
    siteTree: {
      loading: 'Seitenstruktur wird geladen...',
      error: 'Seitenstruktur konnte nicht geladen werden',
      noData: 'Keine Seitenstruktur. Führe zuerst ein Audit durch.',
      noSearchResults: 'Keine Seiten entsprechen deiner Suche.',
      pages: 'Seiten',
      searchPlaceholder: 'URL, Titel oder Breadcrumb suchen…',
      expandAll: 'Alle aufklappen',
      collapseAll: 'Alle zuklappen',
      expand: 'Aufklappen',
      collapse: 'Zuklappen',
      openPage: 'Seite öffnen',
      breadcrumbMode: 'Breadcrumb-Hierarchie aktiv',
      maxBreadcrumbDepth: 'Max. semantische Tiefe',
      maxCrawlDepth: 'Max. Crawl-Tiefe',
      pagesWithBreadcrumbs: 'Seiten mit Breadcrumbs',
      depthHintBreadcrumb: 'L = semantische Ebene aus dem Breadcrumb-Pfad (empfohlen für Flat-URL-Shops wie JTL). Startseite = L0, Kategorie = L1, Unterkategorie = L2, Produkt = L3+.',
      depthHintCrawl: 'D = BFS-Crawl-Tiefe ab der Startseite. Startseite = D0, direkt verlinkte Seiten = D1 usw.',
      scoreDistribution: 'Score-Verteilung',
      pageTypes: 'Seitentypen',
      overallScore: 'Gesamtscore',
      url: 'URL',
      pageType: 'Seitentyp',
      depth: 'Tiefe',
      statusCode: 'Statuscode',
      children: 'Unterseiten',
      breadcrumbTrail: 'Breadcrumb-Pfad',
      copyUrl: 'URL kopieren',
      scoreGood: 'Gut',
      scoreMedium: 'Verbesserungswürdig',
      scoreBad: 'Kritisch',
      scoreNone: 'Nicht bewertet',
      treeLabel: 'Seitenstruktur-Baum',
      closeDetail: 'Details schließen',
      treeView: 'Baum',
      graphView: 'Graph',
      filterByType: 'Nach Typ filtern',
      clearFilter: 'Filter aufheben',
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
      fitView: 'Ansicht anpassen',
      expandNode: 'Kinder aufklappen',
      collapseNode: 'Kinder einklappen',
      nodeLimitWarning: 'Zeige erste {n} Knoten — Zweige einklappen für mehr',
      graphPanHint: 'Ziehen zum Verschieben · Scrollen zum Zoomen',
    },
    technical: {
      links: 'Links',
      duplicates: 'Duplikate',
      redirects: 'Weiterleitungen',
      hreflang: 'Hreflang',
      schema: 'Schema',
      images: 'Bilder',
      resources: 'Ressourcen',
      cwv: 'CWV',
      robotsTxt: 'robots.txt',
      sitemap: 'Sitemap',
      mobile: 'Mobil',
      schemaValidation: 'Schema-Validierung',
      internalLinks: 'Link-Audit',
      redirectChains: 'Weiterleitungsketten',
      hreflangTags: 'Hreflang-Tags',
      imageAudit: 'Bild-Audit',
      jscssFonts: 'JS / CSS / Schriften',
      noData: 'Keine Daten für diesen Audit verfügbar.',
      noDuplicates: 'Keine doppelten Titel oder Meta-Beschreibungen gefunden.',
      noRedirects: 'Keine Weiterleitungsseiten gefunden.',
      noHreflang: 'Keine Hreflang-Tags gefunden.',
      noSchema: 'Kein Schema-Markup gefunden.',
      noImages: 'Keine Bilder gefunden.',
      noResources: 'Keine externen Ressourcen gefunden.',
      missingAltOnly: 'Nur fehlende Alt-Texte',
      renderBlockingOnly: 'Nur render-blockierende',
      pagesCrawled: 'Seiten',
      uniquePages: 'Einzigartig',
      httpsPages: 'HTTPS',
      nonHttpsPages: 'Nicht-HTTPS',
      avgCrawlDepth: 'Tiefe',
      avgPageSize: 'Seitengröße',
      avgLoadTime: 'Ladezeit',
      schemaPages: 'Schema',
    },
    cwv: {
      noData: 'Keine CWV-Daten',
      noDataDescription: 'Core Web Vitals werden während des Crawls gemessen. Aktivieren Sie "Core Web Vitals messen" in den Crawl-Einstellungen.',
      distribution: 'Verteilung',
    },
    robots: {
      notFound: 'Keine robots.txt gefunden',
      notFoundDescription: 'Eine robots.txt-Datei hilft Suchmaschinen, Ihre Website richtig zu crawlen.',
    },
    sitemap: {
      title: 'Sitemap-Analyse',
      notFound: 'Keine Sitemap gefunden',
      notFoundDescription: 'Eine XML-Sitemap hilft Suchmaschinen, Ihre Seiten zu entdecken.',
      totalUrls: 'In Sitemap',
      crawled: 'Gecrawlt',
      notCrawled: 'Nicht gecrawlt',
      orphanPages: 'Verwaiste Seiten',
      coverage: 'Abdeckung',
      urls: 'Sitemap-URLs',
    },
    mobile: {
      noData: 'Keine Mobile-Daten',
      noDataDescription: 'Aktivieren Sie "Mobile-Friendly Check" in den Crawl-Einstellungen.',
      friendly: 'Mobil-freundlich',
      withIssues: 'Mit Problemen',
      missingViewport: 'Ohne Viewport',
      issueTypes: 'Problemtypen',
      pageResults: 'Seitenergebnisse',
    },
    schemaValidation: {
      noData: 'Keine Schema-Markups gefunden',
      noDataDescription: 'Keine strukturierten Daten auf den gecrawlten Seiten erkannt.',
      total: 'Gesamt',
      valid: 'Gültig',
      invalid: 'Ungültig',
      byType: 'Nach Typ',
      results: 'Validierungsergebnisse',
    },
    comparison: {
      title: 'Crawls vergleichen',
      selectPrevious: 'Vorherigen Crawl auswählen...',
      noPastAudits: 'Keine früheren Crawls zum Vergleichen verfügbar.',
      openPrevious: 'Öffnen',
      results: 'Vergleichsergebnisse',
      metric: 'Metrik',
      previous: 'Vorher',
      current: 'Aktuell',
      change: 'Änderung',
    },
    cannibalization: {
      title: 'Keyword-Kannibalisierung',
      found: '{count} Keywords auf mehreren Seiten gefunden',
      recommendedPage: 'Empfohlene Hauptseite',
      competingPages: 'Konkurrierende Seiten',
      severity: {
        critical: 'Kritisch (3+ Seiten)',
        warning: 'Warnung (2 Seiten)',
      },
      advice: 'Erwägen Sie die Konsolidierung von Inhalten oder das Hinzufügen von Canonical-Tags',
      noConflicts: 'Keine Keyword-Konflikte erkannt',
      pages: 'Seiten',
      wdfIdf: 'WDF*IDF',
      viewDetails: 'Details anzeigen',
      topOffenders: 'Top Kannibalisierungs-Probleme',
      loadHint: 'Analysieren Sie Keyword-Überschneidungen, um Kannibalisierungsprobleme zu finden.',
      loadButton: 'Kannibalisierungs-Analyse laden',
    },
    keywords: {
      title: 'Keyword-Tracking',
      addKeyword: 'Keyword hinzufügen',
      addKeywords: 'Keywords hinzufügen',
      keyword: 'Keyword',
      position: 'Position',
      change: 'Änderung',
      volume: 'Suchvolumen',
      difficulty: 'Schwierigkeit',
      url: 'Ranking URL',
      tracked: 'Verfolgte Keywords',
      improved: 'Verbessert',
      declined: 'Verschlechtert',
      noChange: 'Keine Änderung',
      addPlaceholder: 'Keyword zum Tracken eingeben...',
      add: 'Keyword hinzufügen',
      noKeywords: 'Noch keine Keywords getrackt. Fügen Sie oben Ihr erstes Keyword hinzu.',
      bulkImport: 'Massenimport',
      bulkImportHint: 'Ein Stichwort pro Zeile eingeben',
      import: 'Importieren',
      checkRanking: 'Ranking prüfen',
      checkRankingTriggered: 'Ranking-Prüfung gestartet',
      dataforseoConsentTitle: 'Bezahlte DataForSEO-SERP-Prüfungen aktivieren?',
      dataforseoConsentBody: 'SERP-Positionsprüfungen nutzen die kostenpflichtige DataForSEO-API. Jede Keyword-Prüfung verbraucht Credits deines DataForSEO-Kontos. Die Kosten werden im API-Ausgaben-Dashboard erfasst.',
      dataforseoConsentAccept: 'Aktivieren & fortfahren',
      dataforseoConsentDecline: 'Nicht jetzt',
      lastChecked: 'Zuletzt geprüft',
      emptyTitle: 'Keine Keywords getrackt',
      emptyDesc: 'Beginnen Sie mit dem Tracking von Keywords, um Ihre Suchrankings zu überwachen',
      competitorInsights: 'Wettbewerber-Keyword-Analyse',
      importKeywords: 'Keywords importieren',
      manualBulk: 'Manuell / Bulk',
      importFromGsc: 'Google Search Console',
      importFromDataForSeo: 'DataForSEO',
      gscImportHint: 'Ruft Keywords live aus der Google Search Console ab. Greift auf Audit-Daten zurück, falls GSC nicht verbunden ist. Bereits getrackte Keywords werden ausgeschlossen.',
      dataforseoDiscoverHint: 'Entdecken Sie Keywords, für die Ihre Domain rankt, über DataForSEO. Bereits getrackte Keywords werden ausgeschlossen.',
      dataforseoCostNotice: 'Dies nutzt die kostenpflichtige DataForSEO-API — jede Suche verbraucht Credits von Ihrem DataForSEO-Konto.',
      minClicks: 'Min. Klicks',
      minImpressions: 'Min. Impressionen',
      maxPosition: 'Max. Position',
      minVolume: 'Min. Suchvolumen',
      searchFilter: 'Keywords filtern...',
      loadGscKeywords: 'Keywords laden',
      discoverKeywords: 'Keywords entdecken',
      discovering: 'Wird gesucht...',
      keywordsFound: 'Keywords gefunden',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
      importSelected: 'Ausgewählte importieren',
      importing: 'Wird importiert...',
      importSuccess: '{count} Keywords importiert',
      noGscData: 'Google Search Console ist nicht verbunden oder keine Keyword-Daten verfügbar.',
      gscNoResults: 'Klicken Sie auf "Keywords laden", um Keywords aus der Google Search Console abzurufen.',
      noDataForSeoResults: 'Klicken Sie auf "Keywords entdecken", um Keywords zu finden, für die Ihre Domain rankt.',
      resultLimit: 'Limit',
      tags: 'Tags',
      priority: 'Priorität',
      intent: 'Absicht',
      branded: 'Marken-Keyword',
      targetUrl: 'Ziel-URL (zugeordnet)',
      currentUrl: 'Ranking-URL (automatisch erkannt)',
      noTargetUrl: 'Keine Ziel-URL festgelegt',
      notes: 'Notizen',
      notesPlaceholder: 'Notizen zu diesem Keyword hinzufügen...',
      source: 'Quelle',
      tag: 'Tag',
      filters: 'Filter',
      clearFilters: 'Zurücksetzen',
      keywordResearch: 'Keyword-Recherche',
      seedKeywords: 'Seed-Keywords',
      seedPlaceholder: 'z.B. SEO Tools, Keyword-Recherche',
      modeSuggestions: 'Vorschläge',
      modeIdeas: 'Ideen',
      runResearch: 'Recherchieren',
      cpc: 'CPC',
      competition: 'Wettbewerb',
      noResearchResults: 'Geben Sie Seed-Keywords ein und klicken Sie auf "Recherchieren", um neue Keyword-Möglichkeiten zu entdecken.',
      // Competitor pull tab (Phase 5)
      competitorPull: 'Mitbewerber-Keywords',
      competitorPullHint: 'Entdecken Sie Keywords, für die Ihr Mitbewerber rankt, via DataForSEO. Bereits getrackte Keywords werden ausgeschlossen.',
      selectCompetitor: 'Mitbewerber',
      selectCompetitorPlaceholder: '— Mitbewerber auswählen —',
      noCompetitorResults: 'Klicken Sie auf "Keywords entdecken", um Keywords zu finden, für die dieser Mitbewerber rankt.',
      // Grouped view (Phase 4)
      viewFlat: 'Flach',
      viewGrouped: 'Gruppiert',
      switchToGrouped: 'Zur gruppierten Ansicht wechseln',
      switchToFlat: 'Zur flachen Ansicht wechseln',
      sourceManual: 'Manuell',
      showingFirst: 'Zeige erste',
      of: 'von',
      switchToFlatForAll: 'Zur flachen Ansicht wechseln, um alle zu sehen.',
      // Lifecycle status labels
      discoveryStatus: 'Status',
      status_discovered: 'Entdeckt',
      status_rediscovered: 'Wiederentdeckt',
      status_active: 'Aktiv',
      status_lost: 'Verloren',
      // Source group filter
      sourceGroup: 'Gruppe',
      // GSC sync button
      syncGsc: 'GSC Sync',
      syncGscTitle: 'Keywords aus den letzten GSC-Crawl-Daten synchronisieren',
      gscPullTitle: 'Alle Keywords pro URL live aus der Google Search Console ziehen (kostenlos, unbegrenzt)',
      gscPulled: '{{n}} Keywords über {{p}} Seiten aus GSC gezogen',
      gscPulledNone: 'GSC-Abzug abgeschlossen — keine neuen Keyword-Daten gefunden',
      gscPullError: 'GSC-Abzug fehlgeschlagen. Ist die Google Search Console verbunden?',
      // Keyword detail panel
      lifecycle: 'Lebenszyklus',
      status: 'Status',
      firstSeen: 'Erstmals gesehen',
      lastSeen: 'Zuletzt gesehen',
      sourceDomain: 'Domain',
      matchingPages: 'Passende Seiten (GSC)',
      matchingPageUrl: 'URL',
      clicks: 'Klicks',
      impressions: 'Impr.',
      ctr: 'CTR',
      noPagesFound: 'Keine passenden Seiten in den GSC-Daten gefunden.',
      crawlFallback: 'Keine GSC-Daten — zeige WDF*IDF-Crawl-Begriffe stattdessen.',
      // View modes (Phase 1)
      keywordView: 'Keywords',
      urlView: 'Nach URL',
      urls: 'URLs',
      urlViewEmpty: 'Keine URL-Daten verfügbar. Führen Sie einen Crawl mit GSC-Zugang durch oder synchronisieren Sie GSC-Keywords.',
      urlSearchPlaceholder: 'Nach URL oder Keyword filtern…',
      cannibalizedWarning: 'Kannibalisierung: rankt auch für',
      keywords: 'Keywords',
      // Pending review queue (Phase 1)
      reviewQueue: 'Prüfen',
      reviewQueueTitle: 'Ausstehende Keyword-Vorschläge',
      reviewQueueDesc: 'Aus der WDF*IDF-Crawl-Analyse generiert. Akzeptieren zum Tracken oder ignorieren.',
      reviewQueueEmpty: 'Keine ausstehenden Vorschläge.',
      reviewAccept: 'Akzeptieren',
      reviewIgnore: 'Ignorieren',
      reviewAcceptAll: 'Alle akzeptieren',
      reviewIgnoreAll: 'Alle ignorieren',
      reviewAccepted: 'Keyword akzeptiert',
      reviewIgnored: 'Keyword ignoriert',
      reviewAllAccepted: 'Alle Vorschläge akzeptiert',
      reviewAllIgnored: 'Alle Vorschläge ignoriert',
      // SERP history (Phase 1)
      noSerpHistory: 'Noch kein Positionsverlauf. Führen Sie "Jetzt prüfen" aus, um mit dem Tracking zu beginnen.',
      latestCheck: 'letzter Check',
      best: 'Beste',
      worst: 'Schlechteste',
      checks: 'Checks',
      date: 'Datum',
      rankingUrl: 'Ranking-URL',
      serpFeatures: 'SERP',
      addTag: 'Tag hinzufügen',
      checkNow: 'Jetzt prüfen',
      openInSerp: 'Im SERP-Monitor öffnen',
    },
    keywordResearch: {
      title: 'Keyword-Recherche',
      subtitle: 'Entdecke Keyword-Chancen für deine Domain — analysiere Inhalte, nutze Quick Wins, schlage Mitbewerber und erweitere mit KI.',
      wdfAnalysis: 'WDF*IDF-Analyse',
      competitorGap: 'Mitbewerber-Gap',
      quickWins: 'Quick Wins',
      aiDiscovery: 'KI-Entdeckung',
      wdfAnalysisDesc: 'URL-basierte Content-Analyse. Wähle eine gecrawlte Seite aus, um ihre wichtigsten Begriffe nach WDF*IDF-Score zu sehen — die Begriffe, die diese Seite inhaltlich definieren. Zum Optimieren von Inhalten oder für fehlende Begriffe verwenden.',
      gapDesc: 'Keywords, für die deine Mitbewerber ranken und die du noch nicht trackst. Die direkteste Quelle neuer Chancen — vollautomatisch aus deiner Mitbewerberliste.',
      quickWinsDesc: 'Keywords, für die du bereits auf Seite 1 rankst (Positionen 4–10). Das sind deine besten Low-Hanging Fruits — ein gezielter Content-Verbesserung auf der Ranking-Seite kann sie in die Top 3 bringen.',
      ideasDesc: 'Automatisch vorausgefüllt mit deiner Projektdomain. Entdecke verwandte Keyword-Chancen via DataForSEO — Seeds für gezieltere Ergebnisse anpassen.',
      selectUrl: 'Seite zur Analyse auswählen',
      urlSearchPlaceholder: 'Seiten nach URL filtern...',
      noPagesFound: 'Keine gecrawlten Seiten gefunden. Zuerst ein Crawl-Audit durchführen.',
      noWdfTerms: 'Keine Content-Begriffe für diese Seite gefunden.',
      selectUrlHint: 'Eine Seite aus der Liste oben auswählen, um die WDF*IDF-Analyse zu sehen.',
      termsFound: 'Begriffe',
      quickWinsCount: 'Quick-Win-Keywords aus GSC',
      noQuickWins: 'Keine Quick-Win-Keywords gefunden. Erfordert verknüpfte Google Search Console und Keywords auf Positionen 4–10.',
      noQuickWinsNoGsc: 'Keine GSC-Daten gefunden. Überprüfe ob Google Search Console in den Einstellungen verbunden ist.',
      noQuickWinsTopRanker: 'GSC liefert {{count}} Keywords — aber alle ranken in den Top 3. Hervorragend! Neue Chancen findest du in den Tabs KI-Entdeckung oder Mitbewerber-Gap.',
      noQuickWinsGscError: 'GSC-Daten konnten nicht geladen werden. Google Search Console Verbindung in den Einstellungen prüfen.',
      gscLive: 'Live GSC',
      gscAudit: 'Crawl-Daten',
      gscAuditFallback: 'Es werden Daten aus dem letzten Crawl-Audit verwendet (keine Live-GSC-Verbindung verfügbar).',
      requiresDataForSeo: 'Benötigt DataForSEO',
      gapLimitLabel: 'Max. Ergebnisse',
      gapCta: 'Wähle oben einen Mitbewerber und klicke auf "Gap-Keywords entdecken".',
      gapApiError: 'Fehler — DataForSEO hat einen Fehler zurückgegeben:',
      noGapResultsEmpty: 'Keine Gap-Keywords für diesen Mitbewerber gefunden. Evtl. ranken sie für bereits getrackte Keywords oder DataForSEO hat keine Daten für ihre Domain.',
      ideasCta: 'Seed-Keywords oben eingeben und auf Entdecken klicken.',
      ideasApiError: 'Recherche fehlgeschlagen — DataForSEO hat einen Fehler zurückgegeben:',
      noQuickWinsLive: 'GSC ist verbunden, aber es wurden keine Keywords auf Positionen 1–10 gefunden. Deine Seite rankt möglicherweise unterhalb von Seite 1, oder GSC hat noch nicht genügend Impressionen gesammelt.',
      noQuickWinsAudit: 'Live-GSC-Verbindung nicht verfügbar und das letzte Crawl-Audit hat keine GSC-Daten für Positionen 1–10. Stelle sicher, dass ein Crawl mit GSC-Zugang abgeschlossen wurde.',
      refreshKeywords: 'Aktualisieren',
      seedLabel: 'Seeds (kommagetrennt)',
      seedPlaceholder: 'z. B. keyword recherche, seo tool, rank tracking...',
      broadIdeasMode: 'Breiter Ideen-Modus (vielfältigere Ergebnisse)',
      autoSeeded: 'Automatisch aus deiner Domain vorausgefüllt: {{domain}}',
      selectCompetitor: 'Mitbewerber',
      noCompetitors: 'Noch keine Mitbewerber erfasst. Füge Mitbewerber zuerst im Mitbewerber-Bereich hinzu.',
      minVolume: 'Min. Volumen',
      discoverGap: 'Gap-Keywords entdecken',
      discovering: 'Wird erkundet...',
      discover: 'Entdecken',
      research: 'Recherchieren',
      researching: 'Wird recherchiert...',
      addToTracking: 'Hinzufügen',
      addAll: 'Alle hinzufügen',
      added: 'Hinzugefügt',
      keyword: 'Keyword',
      wdfIdf: 'WDF*IDF',
      inTitle: 'Titel',
      inH1: 'H1',
      searchVolume: 'Suchvolumen',
      cpc: 'CPC',
      competition: 'Wettbewerb',
      clicks: 'Klicks',
      impressions: 'Impressionen',
      position: 'Position',
      landingPage: 'Landingpage',
      gapResultsFor: 'Gap-Keywords für',
      filterPlaceholder: 'Keywords filtern...',
      noResults: 'Keine Ergebnisse. Andere Seed-Keywords ausprobieren oder DataForSEO-Konfiguration prüfen.',
      noGapResults: 'Keine Gap-Keywords gefunden. Auf "Gap-Keywords entdecken" klicken oder DataForSEO-Konfiguration prüfen.',
      addToMap: "Zur Map hinzufügen",
      aiResearch: "KI-Recherche",
      llmDesc: "Prüfen, ob KI-Assistenten Sie für Ihre Keywords nennen.",
      opportunities: "Chancen",
    },
    serp: {
      title: 'SERP-Monitor',
      history: 'Positionsverlauf',
      snapshot: 'SERP Snapshot',
      features: 'SERP Features',
      localPack: 'Local Pack',
      featuredSnippet: 'Featured Snippet',
      peopleAlsoAsk: 'Ähnliche Fragen',
      noData: 'Noch keine SERP-Daten verfügbar.',
      rankingDistribution: 'Ranking-Verteilung',
      positions1_3: 'Pos 1-3',
      positions4_10: 'Pos 4-10',
      positions11_20: 'Pos 11-20',
      positions21_50: 'Pos 21-50',
      positions51Plus: 'Pos 51+',
      notRanked: 'Nicht gerankt',
      positionHistory: 'Positionsverlauf',
      noHistory: 'Kein Positionsverlauf verfügbar',
      serpFeatures: 'SERP-Features',
      bigImprovement: 'Große Verbesserung',
      bigDecline: 'Großer Rückgang',
      improved: 'Verbessert',
      declined: 'Verschlechtert',
      stable: 'Stabil',
      newRankings: 'Neu',
      lostRankings: 'Verloren',
      days30: '30 Tage',
      days90: '90 Tage',
      days180: '180 Tage',
      notEnoughData: 'Nicht genügend Daten für Trenddiagramm',
      positionOverTime: 'Position über Zeit',
      dataforseoConsentTitle: 'Bezahlte DataForSEO-SERP-Prüfungen aktivieren?',
      dataforseoConsentBody: 'SERP-Positionsprüfungen nutzen die kostenpflichtige DataForSEO-API. Jede Keyword-Prüfung verbraucht Credits deines DataForSEO-Kontos. Die Kosten werden im API-Ausgaben-Dashboard erfasst.',
      dataforseoConsentAccept: 'Aktivieren & fortfahren',
      dataforseoConsentDecline: 'Nicht jetzt',
    },
    backlinks: {
      title: 'Backlink-Profil',
      emptyTitle: 'Noch keine Backlink-Daten',
      emptyDesc: 'Verbinden Sie eine Datenquelle oder führen Sie einen Backlink-Check durch',
      overview: 'Übersicht',
      referringDomains: 'Verweisende Domains',
      anchorTexts: 'Ankertexte',
      topPages: 'Top-Seiten',
      history: 'Verlauf',
      totalBacklinks: 'Backlinks gesamt',
      totalReferring: 'Verweisende Domains',
      dofollowPercent: 'Dofollow %',
      brokenLinks: 'Defekte Links',
      triggerCheck: 'Jetzt prüfen',
      checking: 'Wird geprüft...',
      domain: 'Domain',
      rank: 'Rang',
      backlinks: 'Backlinks',
      linksTo: 'Verlinkt auf',
      dofollow: 'Dofollow',
      firstSeen: 'Erstmals gesehen',
      anchor: 'Ankertext',
      pageUrl: 'Seiten-URL',
      date: 'Datum',
      newBacklinks: 'Neu',
      lostBacklinks: 'Verloren',
      noData: 'Keine Daten verfügbar',
      domainAuthority: 'Domain Authority',
      anchorText: 'Ankertext',
      sourceUrl: 'Quell-URL',
      targetUrl: 'Ziel-URL',
      status: 'Status',
      noBacklinks: 'Noch keine Backlinks gefunden.',
      source: 'Quelle',
      target: 'Ziel',
      authority: 'Autorität',
      type: 'Typ',
      fetchFromApi: 'Von DataForSEO abrufen',
      fetchSettings: 'Abruf-Einstellungen',
      numberOfResults: 'Anzahl der Ergebnisse',
      fetchNow: 'Jetzt abrufen',
      fetching: 'Wird abgerufen...',
      fetchSuccess: 'Backlinks erfolgreich abgerufen',
      fetchHint: 'Ruft Backlink-Daten von DataForSEO ab und speichert sie in der Datenbank',
      lastFetched: 'Zuletzt abgerufen',
      lastFetchCost: 'Kosten letzter Abruf',
      costLabel: 'Kosten',
      costNotice: 'Nutzt die kostenpflichtige DataForSEO-API. Die exakten Kosten dieses Abrufs werden im API-Ausgaben-Dashboard protokolliert.',
      dataforseoConsentTitle: 'Bezahlte DataForSEO-Backlink-Analyse aktivieren?',
      dataforseoConsentBody: 'Backlink-Abrufe und -Prüfungen nutzen die kostenpflichtige DataForSEO-API. Jeder Abruf verbraucht Credits deines DataForSEO-Kontos. Die Kosten werden im API-Ausgaben-Dashboard erfasst.',
      dataforseoConsentAccept: 'Aktivieren & fortfahren',
      dataforseoConsentDecline: 'Nicht jetzt',
      storedResults: 'Gespeichert',
      linkType: 'Link-Typ',
      // Competitor mode
      viewingOwn: 'Eigene Domain',
      viewingCompetitor: 'Wettbewerber',
      switchToOwn: 'Zur eigenen Domain wechseln',
      selectCompetitor: 'Domain auswählen',
      allDomains: 'Alle Domains',
      noCompetitors: 'Noch keine Wettbewerber. Wettbewerber auf der Wettbewerber-Seite hinzufügen.',
      competitorBacklinks: 'Wettbewerber-Backlinks',
      // Filters
      filters: 'Filter',
      minAuthority: 'Mind. Authority',
      allLinkTypes: 'Alle Typen',
      allStatuses: 'Alle Status',
      active: 'Aktiv',
      lost: 'Verloren',
      broken: 'Defekt',
      // Tabs
      compare: 'Vergleich',
      backlinkGap: 'Backlink Gap',
      // Compare view
      compareTitle: 'Backlink-Vergleich',
      compareEmpty: 'Wählen Sie Wettbewerber für den Vergleich aus.',
      compareSelectHint: 'Wettbewerber oben hinzufügen, um sie in den Vergleich einzubeziehen',
      ownDomain: 'Eigene Domain',
      avgAuthority: 'Ø Authority',
      // Backlink gap
      backlinkGapTitle: 'Backlink Gap',
      backlinkGapDesc: 'Domains, die auf den Wettbewerber verlinken, aber nicht auf Sie — Link-Building-Chancen.',
      backlinkGapEmpty: 'Keine Gap-Daten. Wettbewerber auswählen und Backlinks zuerst abrufen.',
      opportunity: 'Chance',
      // Fetch for competitor
      fetchForCompetitor: 'Für {domain} abrufen',
      confirmFetchCompetitor: 'Backlinks für Wettbewerber {domain} werden abgerufen. Fortfahren?',
    },
    competitors: {
      title: 'Wettbewerbsanalyse',
      addCompetitor: 'Wettbewerber hinzufügen',
      domain: 'Domain',
      organicKeywords: 'Keywords',
      organicTraffic: 'Organischer Traffic',
      domainAuthority: 'DA',
      overlapScore: 'Keyword-Überschneidung',
      comparison: 'Vergleich',
      addPlaceholder: 'z.B. wettbewerber-domain.de',
      add: 'Hinzufügen',
      addSuccess: 'Wettbewerber hinzugefügt',
      noCompetitors: 'Noch keine Wettbewerber getrackt. Fügen Sie oben eine Wettbewerber-URL hinzu.',
      empty: 'Keine Wettbewerber getrackt. Fügen Sie oben eine Domain hinzu oder verwalten Sie diese auf der Wettbewerber-Seite.',
      discoverMore: 'Weitere entdecken',
      discoverCostNotice: 'Dies nutzt die kostenpflichtige DataForSEO-Labs-API — jede Suche verbraucht Credits von Ihrem DataForSEO-Konto.',
      discovering: 'Wird gesucht...',
      addSelected: 'Ausgewählte hinzufügen',
      enrich: 'Aktualisieren',
      enriching: 'Wird aktualisiert...',
      keywordOverlap: 'Keyword-Überschneidung',
      contentGap: 'Content-Lücke',
      backlinkGap: 'Backlink-Lücke',
      keyword: 'Keyword',
      searchVolume: 'Suchvolumen',
      yourPosition: 'Deine Pos.',
      competitorPosition: 'Wettb. Pos.',
      cpc: 'CPC',
      referringDomain: 'Domain',
      rank: 'Rang',
      backlinks: 'Backlinks',
      showMore: 'Mehr anzeigen...',
      noData: 'Keine Daten verfügbar',
      emptyTitle: 'Keine Wettbewerber hinzugefügt',
      emptyDesc: 'Fügen Sie Wettbewerber-Domains hinzu, um deren Performance zu verfolgen',
      startAudit: 'Audit für diesen Wettbewerber starten',
      auditStarted: 'Audit für {domain} gestartet',
      manageAll: 'Wettbewerber verwalten',
      projectBadge: 'Projekt',
      discoveredBadge: 'Entdeckt',
      projectLevel: 'Aus Projekteinstellungen',
      removeFromProject: 'Projekt-Wettbewerber müssen in den Projekteinstellungen entfernt werden.',
      promotedToProject: 'Wettbewerber zu Projekteinstellungen hinzugefügt',
      addToProject: 'Zum Projekt',
      promoteToProject: 'Auch zu Projekt-Wettbewerbern hinzufügen',
      projectCompetitors: 'Projektebene',
      seoCompetitors: 'Nur SEO',
      confirmDelete: 'Soll dieser Wettbewerber wirklich entfernt werden? Alle Gap-Analysedaten gehen verloren.',
      dataforseoConsentTitle: 'Kostenpflichtige DataForSEO-Analyse aktivieren?',
      dataforseoConsentBody: 'Wettbewerber-Entdeckung, -Anreicherung, Keyword-Overlap und Content-Gap nutzen die kostenpflichtige DataForSEO-Labs-API. Jede Abfrage verbraucht Credits Ihres DataForSEO-Kontos. Kosten werden im API-Ausgaben-Dashboard erfasst.',
      dataforseoConsentAccept: 'Aktivieren & fortfahren',
      dataforseoConsentDecline: 'Jetzt nicht',
      addManual: 'Manuell hinzufügen',
      discover: 'Entdecken',
      backlinkGapNotice: 'Backlink-Gap zeigt zwischengespeicherte verweisende Domains aus Ihrem letzten Backlink-Abruf — aktualisieren Sie über einen Backlink-Abruf auf der Backlink-Profil-Seite.',
      exportReport: 'Bericht exportieren',
      masterSourceNotice: 'Ihre eigene Domain nutzt die Google Search Console (organischer Traffic) und Ihre getrackten Keywords, während Wettbewerber DataForSEO-Schätzungen verwenden. Die Quellen unterscheiden sich — vergleichen Sie daher Trends statt absoluter Werte.',
    },
    competitorPull: {
      title: 'Wettbewerber-Pull',
      tabKeywords: 'Keyword-Entdeckung',
      tabAudit: 'Vollständiger Crawl',
      dataSource: 'Datenquelle',
      modeDomain: 'Domain-Keywords',
      modeDomainDesc: 'Alle Keywords, für die die Domain rankt',
      modeUrlList: 'Seiten-Keywords',
      modeUrlListDesc: 'Keywords für bestimmte Seiten',
      urlList: 'URLs (eine pro Zeile)',
      urlListHint: 'Vollständige URLs der Wettbewerber-Seiten eingeben (max. 50)',
      keywordsPerUrl: 'Max. Keywords pro URL',
      keywordLimit: 'Keyword-Limit',
      positionMin: 'Min. Position',
      positionMax: 'Max. Position',
      minVolume: 'Mindestsuchvolumen',
      loadPreview: 'Vorschau laden',
      loading: 'Vorschau wird geladen...',
      previewFound: '{n} Keywords gefunden',
      previewEmpty: 'Keine Keywords für diese Filter gefunden.',
      selectAll: 'Alle auswählen',
      deselectAll: 'Alle abwählen',
      posHeader: 'Pos.',
      scheduleSection: 'Wiederkehrender Zeitplan',
      scheduleHint: 'Diesen Keyword-Pull automatisch nach Zeitplan wiederholen und neue Keywords importieren.',
      schedWeekly: 'Wöchentlich',
      schedMonthly: 'Monatlich',
      schedDay: 'Tag',
      schedTime: 'Uhrzeit (UTC)',
      scheduleSaved: 'Zeitplan gespeichert',
      importN: '{n} Keywords importieren',
      importButton: 'Keywords importieren',
      importSuccess: '{n} Keywords importiert',
      auditDesc: 'Vollständigen Site-Crawl der Wettbewerber-Domain starten, um Seitenstruktur, Inhalte und technische SEO zu analysieren.',
      auditTarget: 'Ziel-Domain',
      auditType: 'Crawl-Typ',
      auditTypeFull: 'Vollständiger Crawl',
      startAudit: 'Vollständigen Crawl starten',
      starting: 'Wird gestartet...',
    },
    schedule: {
      title: 'Zeitplan',
      runNow: 'Jetzt ausführen',
      lastRun: 'Letzter Lauf',
      nextRun: 'Nächster Lauf',
      keywordCheckDesc: 'Wöchentliche Keyword-Checks erkennen Ranking-Verluste frühzeitig, bevor Traffic verloren geht.',
      backlinkCheckDesc: 'Regelmäßiges Backlink-Monitoring hilft verlorene Links und neue Linkbuilding-Chancen zu erkennen.',
      competitorEnrichDesc: 'Regelmäßige Wettbewerber-Datenaktualisierung hält Ihre Wettbewerbsinformationen aktuell.',
      recentRuns: 'Letzte Ausführungen',
      noRecentRuns: 'Noch keine Ausführungen',
    },
    issues: {
      tracking: 'Issue-Tracking',
      statusLabel: 'Status',
      statusNew: 'Neu',
      statusAcknowledged: 'Bestätigt',
      statusInProgress: 'In Bearbeitung',
      statusFixed: 'Behoben',
      statusWontFix: 'Nicht beheben',
      statusReopened: 'Wiedereröffnet',
      fixedSinceLastAudit: 'Seit letztem Audit behoben',
      newIssue: 'Neues Issue',
      persisting: 'Bestehend',
      regression: 'Regression',
      bulkActions: 'Massenaktionen',
      selectAll: 'Alle auswählen',
      updateStatus: 'Status aktualisieren',
      resolutionProgress: 'Issue-Lösungsfortschritt',
      resolved: 'gelöst',
      noTrackedIssues: 'Keine verfolgten Issues',
      addNotes: 'Notizen hinzufügen...',
    },
    pageHealth: {
      title: 'Seiten-Gesundheitsprofil',
      backlinksToPage: 'Backlinks zu dieser Seite',
      keywordsTargeting: 'Keywords für diese Seite',
      gscPerformance: 'Search Console Leistung',
      noBacklinks: 'Keine Backlinks für diese Seite gefunden',
      noKeywords: 'Keine verfolgten Keywords zeigen auf diese Seite',
      noGscData: 'Keine Search Console Daten verfügbar',
      healthScore: 'Gesundheitswert',
      clicks: 'Klicks',
      impressions: 'Impressionen',
      avgPosition: 'Ø Position',
      topQueries: 'Top-Suchanfragen',
    },
    alerts: {
      title: 'SEO-Warnungen',
      positionDrop: '{keyword} um {count} Positionen gefallen (jetzt #{position})',
      positionGain: '{keyword} um {count} Positionen gestiegen (jetzt #{position})',
      lostRanking: '{keyword} hat Ranking verloren',
      newRanking: '{keyword} auf Position #{position} erschienen',
      backlinksLost: '{count} Backlinks verloren',
      scoreDrop: 'Audit-Score von {old} auf {new} gefallen',
      allClear: 'Alles klar — keine Warnungen',
      markRead: 'Als gelesen markieren',
      clearAll: 'Alle löschen',
      unread: 'ungelesen',
    },
  },
  ads: {
    dashboard: {
      title: 'Ads Dashboard',
      comingSoon: 'Demnächst verfügbar',
      comingSoonDesc: 'Das Ads Dashboard befindet sich derzeit in Entwicklung und wird bald verfügbar sein.',
    },
  },
  campaigns: {
    manager: {
      title: 'Kampagnenverwaltung',
      newCampaign: 'Neue Kampagne',
      name: 'Kampagnenname',
      platform: 'Plattform',
      status: 'Status',
      budget: 'Budget',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      impressions: 'Impressionen',
      clicks: 'Klicks',
      conversions: 'Conversions',
      ctr: 'CTR',
      cpc: 'CPC',
      roas: 'ROAS',
      create: 'Kampagne erstellen',
      noCampaigns: 'Noch keine Kampagnen. Erstellen Sie Ihre erste Kampagne.',
    },
    ads: {
      title: 'Anzeigenleistung',
      adGroups: 'Anzeigengruppen',
      adCopy: 'Anzeigentext',
      headline: 'Überschrift',
      description: 'Beschreibung',
      displayUrl: 'Anzeige-URL',
      performance: 'Leistung',
      abTesting: 'A/B-Tests',
      winner: 'Gewinner',
      confidence: 'Konfidenz',
      noAds: 'Keine Anzeigen gefunden.',
      name: 'Anzeigenname',
      impressions: 'Impressionen',
      clicks: 'Klicks',
      ctr: 'CTR',
      cost: 'Kosten',
    },
    budgets: {
      title: 'Budget-Verwaltung',
      daily: 'Tagesbudget',
      total: 'Gesamtbudget',
      spent: 'Heute ausgegeben',
      remaining: 'Verbleibend',
      forecast: 'Monatsprognose',
      overPace: 'Überverbrauch',
      activeCampaigns: 'aktive Kampagnen',
      alertsCount: 'Aktive Warnungen',
      activeAlerts: 'Budget-Warnungen',
      burnRate: 'Verbrauchsrate',
      noAlerts: 'Keine Budget-Warnungen',
      allGood: 'Alle Kampagnen liegen innerhalb der Budget-Schwellenwerte.',
    },
    adGroups: {
      title: 'Anzeigengruppen',
      newAdGroup: 'Neue Anzeigengruppe',
      campaign: 'Kampagne',
      defaultBid: 'Standard-Gebot',
    },
    seaKeywords: {
      title: 'SEA Keywords',
      keyword: 'Keyword',
      matchType: 'Übereinstimmungstyp',
      bid: 'Gebot',
      qualityScore: 'Qualitätsfaktor',
      addKeyword: 'Keyword hinzufügen',
      exact: 'Genau',
      phrase: 'Phrase',
      broad: 'Weitgehend',
    },
  },
  sea: {
    performance: {
      title: 'Kampagnenleistung',
      subtitle: 'Verfolgen und analysieren Sie Ihre SEA-Kampagnen-Metriken',
      selectCampaign: 'Kampagne auswählen',
      dateRange: 'Zeitraum',
      last7d: 'Letzte 7 Tage',
      last30d: 'Letzte 30 Tage',
      last90d: 'Letzte 90 Tage',
      impressions: 'Impressionen',
      clicks: 'Klicks',
      ctr: 'CTR',
      spend: 'Ausgaben',
      conversions: 'Conversions',
      roas: 'ROAS',
      date: 'Datum',
      dailyBreakdown: 'Tägliche Aufschlüsselung',
      noData: 'Keine Leistungsdaten verfügbar. Führen Sie zuerst eine Performance-Synchronisierung durch.',
    },
    sync: {
      title: 'Google Ads Synchronisierung',
      customerId: 'Kunden-ID',
      syncNow: 'Jetzt synchronisieren',
      syncing: 'Synchronisiere...',
      taskId: 'Aufgaben-ID',
      status: 'Status',
      lastSynced: 'Zuletzt synchronisiert',
      pushToGoogle: 'Zu Google hochladen',
      pushing: 'Hochladen...',
      noCampaigns: 'Keine Kampagnen gefunden. Synchronisieren Sie zuerst Ihr Google Ads Konto.',
    },
    keywordResearch: {
      title: 'Keyword-Recherche',
      seedKeywords: 'Ausgangskeywords',
      seedPlaceholder: 'Keywords eingeben, kommagetrennt',
      plannerTab: 'Keyword-Planer',
      aiTab: 'KI-Erweiterung',
      research: 'Recherchieren',
      expand: 'Erweitern',
      researching: 'Recherchiere...',
      expanding: 'Erweitere...',
      keyword: 'Keyword',
      avgSearches: 'Durchschn. monatliche Suchen',
      competition: 'Wettbewerb',
      bidLow: 'Gebot (Niedrig)',
      bidHigh: 'Gebot (Hoch)',
      intent: 'Intention',
      matchType: 'Match-Typ Vorschlag',
      estCompetition: 'Geschätzter Wettbewerb',
      noResults: 'Noch keine Ergebnisse. Geben Sie Ausgangskeywords ein und klicken Sie auf Recherchieren oder Erweitern.',
    },
    negativeKeywords: {
      title: 'Negative Keywords',
      keyword: 'Keyword',
      matchType: 'Match-Typ',
      addNegative: 'Negatives Keyword hinzufügen',
      placeholder: 'Keyword eingeben',
      exact: 'Genau passend',
      phrase: 'Passende Wortgruppe',
      broad: 'Weitgehend passend',
      suggestNegatives: 'Negative vorschlagen',
      suggesting: 'Schlage vor...',
      suggestions: 'KI-Vorschläge',
      noKeywords: 'Noch keine negativen Keywords.',
      add: 'Hinzufügen',
    },
    searchTerms: {
      title: 'Suchbegriffe-Bericht',
      searchTerm: 'Suchbegriff',
      matchedKeyword: 'Zugeordnetes Keyword',
      matchType: 'Match-Typ',
      impressions: 'Impressionen',
      clicks: 'Klicks',
      conversions: 'Conversions',
      cost: 'Kosten',
      isNegative: 'Negativ',
      addNegative: 'Als Negativ hinzufügen',
      noTerms: 'Keine Suchbegriffe gefunden.',
      negativeSuggestions: 'Negative Keyword Vorschläge',
      addAsNegative: 'Als Negativ hinzufügen',
      noSuggestions: 'Keine negativen Keyword-Vorschläge gefunden.',
      added: 'Hinzugefügt',
      reasonHighCost: 'Hohe Kosten, keine Conversions',
      reasonLowCTR: 'Viele Impressionen, keine Klicks',
      reasonHighCPA: 'Hohe Kosten pro Conversion',
    },
    auctionInsights: {
      title: 'Auktionsdaten',
      competitor: 'Wettbewerber',
      impressionShare: 'Impressionenanteil',
      overlapRate: 'Überlappungsrate',
      outrankingShare: 'Übertreffungsanteil',
      positionAbove: 'Position-über-Rate',
      topOfPage: 'Rate oberer Seitenbereich',
      absTopOfPage: 'Rate oberste Position',
      noInsights: 'Keine Auktionsdaten verfügbar.',
    },
    products: {
      title: 'Produktmanager',
      merchantId: 'Händler-ID',
      syncProducts: 'Produkte synchronisieren',
      syncing: 'Synchronisiere...',
      productTitle: 'Titel',
      brand: 'Marke',
      condition: 'Zustand',
      availability: 'Verfügbarkeit',
      approvalStatus: 'Genehmigungsstatus',
      offerId: 'Angebots-ID',
      performance: 'Leistung',
      insights: 'Einblicke',
      noProducts: 'Keine Produkte gefunden. Geben Sie Ihre Händler-ID ein und synchronisieren Sie.',
    },
    shopping: {
      title: 'Shopping-Kampagnen',
      settings: 'Shopping-Einstellungen',
      merchantId: 'Händler-ID',
      feedLabel: 'Feed-Label',
      priority: 'Priorität',
      enableLocal: 'Lokales Inventar aktivieren',
      saveSettings: 'Einstellungen speichern',
      saving: 'Speichere...',
      assetGroups: 'Asset-Gruppen',
      createAssetGroup: 'Asset-Gruppe erstellen',
      name: 'Name',
      status: 'Status',
      finalUrls: 'Finale URLs (eine pro Zeile)',
      headlines: 'Überschriften (eine pro Zeile)',
      descriptions: 'Beschreibungen (eine pro Zeile)',
      listingGroups: 'Listing-Gruppen',
      dimensionType: 'Dimensionstyp',
      caseValue: 'Fallwert',
      noAssetGroups: 'Keine Asset-Gruppen gefunden.',
      noListingGroups: 'Keine Listing-Gruppen gefunden.',
    },
    audiences: {
      title: 'Zielgruppen-Manager',
      segmentsTab: 'Segmente',
      targetingTab: 'Kampagnen-Targeting',
      remarketingTab: 'Remarketing-Tags',
      name: 'Name',
      type: 'Typ',
      sourceType: 'Quellentyp',
      sizeEstimate: 'Geschätzte Größe',
      status: 'Status',
      description: 'Beschreibung',
      createSegment: 'Segment erstellen',
      bidModifier: 'Gebotsmodifikator',
      targetingSetting: 'Targeting-Einstellung',
      attachAudience: 'Zielgruppe zuweisen',
      detach: 'Entfernen',
      tagName: 'Tag-Name',
      tagType: 'Tag-Typ',
      snippet: 'Code-Snippet',
      createTag: 'Tag erstellen',
      noSegments: 'Keine Zielgruppensegmente gefunden.',
      noAudiences: 'Keine Zielgruppen dieser Kampagne zugewiesen.',
      noTags: 'Keine Remarketing-Tags gefunden.',
    },
    bidRules: {
      title: 'Gebotsregeln',
      evaluateAll: 'Alle Regeln auswerten',
      evaluating: 'Werte aus...',
      name: 'Name',
      ruleType: 'Regeltyp',
      active: 'Aktiv',
      conditions: 'Bedingungen (JSON)',
      actions: 'Aktionen (JSON)',
      lastEvaluated: 'Zuletzt ausgewertet',
      createRule: 'Regel erstellen',
      editRule: 'Regel bearbeiten',
      logs: 'Ausführungsprotokolle',
      timestamp: 'Zeitstempel',
      actionTaken: 'Ausgeführte Aktion',
      oldValue: 'Alter Wert',
      newValue: 'Neuer Wert',
      triggered: 'Ausgelöst',
      noRules: 'Noch keine Gebotsregeln erstellt.',
      noLogs: 'Keine Ausführungsprotokolle für diese Regel.',
    },
    recommendations: {
      title: 'Empfehlungen',
      generate: 'Empfehlungen generieren',
      generating: 'Generiere...',
      allCampaigns: 'Alle Kampagnen',
      apply: 'Anwenden',
      dismiss: 'Verwerfen',
      impact: 'Auswirkung',
      priority: 'Priorität',
      noRecommendations: 'Noch keine Empfehlungen. Klicken Sie auf Generieren, um Ihre Kampagnen zu analysieren.',
    },
    nav: {
      performance: 'Leistung',
      sync: 'Google Ads Sync',
      keywordResearch: 'Keyword-Recherche',
      negativeKeywords: 'Negative Keywords',
      searchTerms: 'Suchbegriffe',
      auctionInsights: 'Auktionsdaten',
      products: 'Produkte',
      shopping: 'Shopping-Kampagnen',
      audiences: 'Zielgruppen',
      bidRules: 'Gebotsregeln',
      recommendations: 'Empfehlungen',
    },
    campaigns: {
      title: 'Kampagnen',
      subtitle: 'Verwalten Sie Ihre Suchwerbe-Kampagnen',
      create: 'Kampagne erstellen',
      totalSpend: 'Gesamtausgaben',
      totalClicks: 'Klicks gesamt',
      activeCampaigns: 'Aktiv',
      allCampaigns: 'Alle Kampagnen',
      campaignName: 'Kampagne',
      platform: 'Plattform',
      budget: 'Budget',
      spend: 'Ausgaben',
      impressions: 'Impressionen',
      clicks: 'Klicks',
      matchType: 'Match-Typ',
      bid: 'Gebot',
      qualityScore: 'Qualitätsfaktor',
      keyword: 'Keyword',
      addKeyword: 'Keyword hinzufügen',
      totalBudget: 'Gesamtes Tagesbudget',
      totalCampaigns: 'Kampagnen gesamt',
      ofTotal: 'von',
      total: 'gesamt',
      empty: 'Noch keine Kampagnen — Google Ads verbinden und Sync ausführen.',
      perfHint: 'Metriken in Performance',
      newCampaign: 'Neue Kampagne',
      newCampaignDesc: 'Erstellen Sie eine neue Werbekampagne',
      wizardDesc: 'Erstellen Sie eine vollständige Werbekampagne mit KI-Unterstützung',
      step1: 'Beschreibung',
      step2: 'KI-Vorschläge',
      step3: 'Einstellungen',
      step4: 'Übersicht',
      productService: 'Produkt / Dienstleistung',
      productServicePlaceholder: 'z.B. Handgefertigte Lederhandtaschen für Frauen — Made in Germany',
      targetAudience: 'Zielgruppe',
      targetAudiencePlaceholder: 'z.B. Frauen 25–45, Premium-Segment',
      usps: 'Alleinstellungsmerkmale (USPs)',
      uspsPlaceholder: 'z.B. kostenloser Versand, 2 Jahre Garantie, vegane Materialien',
      tone: 'Ton',
      describeRequired: 'Bitte beschreiben Sie zuerst Ihr Produkt oder Ihre Dienstleistung',
      generate: 'KI-Vorschläge generieren',
      generating: 'Wird generiert...',
      regenerate: 'Neu generieren',
      suggestions: 'Vorschläge für Sie',
      aiIntro: 'Die KI analysiert Ihre Eingabe und schlägt Kampagnennamen, Keywords, Anzeigentexte und eine Gebotsstrategie vor',
      suggestError: 'Vorschläge konnten nicht generiert werden. Bitte versuchen Sie es erneut.',
      generateFirst: 'Generieren Sie zuerst KI-Vorschläge oder geben Sie einen Namen ein',
      keywordSuggestions: 'Keywords',
      adCopySuggestions: 'Anzeigentexte',
      biddingSuggestions: 'Gebotsstrategie',
      campaignType: 'Kampagnentyp',
      status: 'Status',
      finalUrl: 'Final-URL',
      landingHint: 'Hinweis',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      targetCpa: 'Ziel-CPA',
      targetRoas: 'Ziel-ROAS',
      googleAdsCustomerId: 'Google-Ads-Kundennummer',
      biddingStrategy: 'Gebotsstrategie',
      keywords: 'Keywords',
      adCopy: 'Anzeigentext',
      namePlaceholder: 'Kampagnenname',
      perDay: '/Tag',
      creating: 'Wird erstellt...',
      nameRequired: 'Kampagnenname ist erforderlich',
      createError: 'Kampagne konnte nicht erstellt werden',
      aiCreditsNotice: 'KI-Verarbeitung genutzt ({{model}}) — Kosten werden verbucht',
      aiFallbackNotice: 'Kein KI-Modell konfiguriert — regelbasierte Vorschläge verwendet',
      aiSpend: 'AI-Kosten',
      aiCalls: 'KI-Aufrufe',
      push: 'Zu Google Ads pushen',
      pushTooltip: 'Kampagne zu Google Ads übertragen',
      pushError: 'Push fehlgeschlagen. Stellen Sie sicher, dass eine Google-Ads-Kundennummer gesetzt und das Google-Ads-Konto verbunden ist.',
      pushSuccess: 'Kampagne erfolgreich zu Google Ads gepusht',
      externalId: 'Google-Ads-ID',
      pushAfterCreate: 'Direkt zu Google Ads pushen',
      pushAfterCreateHint: 'Erfordert eine Google-Ads-Kundennummer und ein verbundenes Konto. Neue Kampagnen werden in Google Ads als PAUSED angelegt.',
      edit: 'Kampagne bearbeiten',
      editCampaign: 'Kampagne bearbeiten',
      editCampaignDesc: 'Entwurf aktualisieren oder Kampagne pausieren, bevor sie zu Google Ads gepusht wird',
      updateError: 'Kampagne konnte nicht aktualisiert werden',
      saving: 'Wird gespeichert...',
      save: 'Speichern',
      customerIdHint: 'Kundennummer muss exakt 10 Ziffern haben',
    },
  },
  automation: {
    dashboard: {
      title: 'Automatisierungs-Dashboard',
      totalWorkflows: 'Workflows gesamt',
      activeWorkflows: 'Aktive Workflows',
      contentPieces: 'Content-Elemente',
      reports: 'Berichte',
      recentExecutions: 'Letzte Ausführungen',
      workflowsByStatus: 'Workflows nach Status',
      contentByType: 'Content nach Typ',
      reportsGenerated: 'Generierte Berichte',
      noExecutions: 'Keine Ausführungen.',
      stepsProgress: 'Schritte',
    },
    workflows: {
      title: 'Automatisierungs-Workflows',
      newWorkflow: 'Neuer Workflow',
      name: 'Workflow-Name',
      trigger: 'Auslöser',
      schedule: 'Zeitplan',
      event: 'Ereignis',
      manual: 'Manuell',
      isActive: 'Aktiv',
      lastRun: 'Letzte Ausführung',
      execute: 'Ausführen',
      create: 'Workflow erstellen',
      noWorkflows: 'Noch keine Workflows. Erstellen Sie Ihren ersten Automatisierungs-Workflow.',
    },
    webhooks: {
      triggerHistory: 'Auslöser-Verlauf',
      eventType: 'Ereignistyp',
      status: 'Status',
      details: 'Details',
      noHistory: 'Kein Auslöser-Verlauf.',
      fired: 'Ausgelöst',
      skipped: 'Übersprungen',
      failed: 'Fehlgeschlagen',
    },
    content: {
      title: 'Content Generator',
      generate: 'Content generieren',
      type: 'Content-Typ',
      blogPost: 'Blogbeitrag',
      metaDescription: 'Meta-Beschreibung',
      adCopy: 'Anzeigentext',
      socialPost: 'Social Media Post',
      topic: 'Thema',
      targetKeywords: 'Ziel-Keywords',
      seoScore: 'SEO Score',
      status: 'Status',
      draft: 'Entwurf',
      review: 'In Prüfung',
      published: 'Veröffentlicht',
      promptPlaceholder: 'Beschreiben Sie den Inhalt, den Sie generieren möchten...',
      generating: 'Generiere...',
      noContent: 'Noch kein Inhalt generiert.',
      contentType: 'Content-Typ',
      keywords: 'Keywords',
      topicPlaceholder: 'Thema oder Titel eingeben...',
      keywordsPlaceholder: 'Keyword1, Keyword2, Keyword3...',
      types: {
        blogPost: 'Blogbeitrag',
        metaDescription: 'Meta-Beschreibung',
        adCopy: 'Anzeigentext',
        socialPost: 'Social Media Post',
      },
    },
    reports: {
      title: 'Berichte',
      generate: 'Bericht erstellen',
      generateDownload: 'Generieren & Herunterladen',
      name: 'Berichtsname',
      type: 'Berichtstyp',
      format: 'Format',
      seoOverview: 'SEO-Übersicht',
      campaignPerformance: 'Kampagnenleistung',
      competitorAnalysis: 'Wettbewerbsanalyse',
      custom: 'Benutzerdefiniert',
      download: 'Herunterladen',
      downloadPdf: 'PDF herunterladen',
      noReports: 'Noch keine Berichte generiert.',
      reportName: 'Berichtsname',
      reportNamePlaceholder: 'Berichtsname eingeben...',
      reportType: 'Berichtstyp',
      emptyTitle: 'Keine Berichte vorhanden',
      emptyDesc: 'Generieren Sie Ihren ersten Bericht, um den Fortschritt zu verfolgen',
      executionHistory: 'Ausführungsverlauf',
      noExecutions: 'Noch keine Ausführungen.',
      exportFailed: 'Export fehlgeschlagen',
      exportSuccess: 'PDF wird heruntergeladen...',
      status: {
        generating: 'Wird generiert...',
        completed: 'Abgeschlossen',
        failed: 'Fehlgeschlagen',
      },
      types: {
        seoAudit: 'SEO-Audit',
        campaignPerformance: 'Kampagnenleistung',
        keywordRanking: 'Keyword-Ranking',
        competitor: 'Wettbewerbsanalyse',
        custom: 'Benutzerdefiniert',
        seo: 'SEO',
        sea: 'SEA',
        bundled: 'Komplett-Bericht',
      },
      schedules: {
        title: 'Geplante Berichte',
        create: 'Zeitplan erstellen',
        frequency: 'Häufigkeit',
        deliveryMethod: 'Liefermethode',
        recipients: 'Empfänger',
        runNow: 'Jetzt ausführen',
        frequencies: {
          manual: 'Manuell',
          weekly: 'Wöchentlich',
          monthly: 'Monatlich',
          quarterly: 'Quartalsweise',
        },
        delivery: {
          download: 'Download',
          email: 'E-Mail',
          both: 'Download & E-Mail',
        },
        noSchedules: 'Keine geplanten Berichte.',
      },
    },
  },
  settings: {
    title: 'Einstellungen',
    description: 'Verwalten Sie die Anwendungskonfiguration für alle Dienste.',
    adminOnly: 'Nur für Administratoren',
    tabs: {
      general: 'Allgemein',
      proxy: 'Proxy',
      crawler: 'Crawler',
      seo: 'SEO',
      sea: 'SEA',
      marketing: 'Marketing',
      email: 'E-Mail',
      ai: 'KI & Modelle',
      users: 'Benutzer',
      generalHint: 'Allgemeine Anwendungseinstellungen.',
      proxyHint: 'Proxy-Einstellungen für das Web-Crawling konfigurieren.',
      crawlerHint: 'Crawl-Engine, Parallelität und Limits konfigurieren.',
      seoHint: 'SEO-bezogene globale Einstellungen.',
      seaHint: 'SEA- / Werbekampagnen-Einstellungen.',
      marketingHint: 'Marketing-Automatisierungs-Einstellungen.',
      emailHint: 'SMTP-E-Mail-Zustellungseinstellungen.',
      aiHint: 'API-Schlüssel verwalten und das KI-Modell für jede Aufgabe wählen.',
      usersHint: 'Benutzer, Rollen und Passwörter verwalten.',
    },
    save: 'Einstellungen speichern',
    saved: 'Einstellungen erfolgreich gespeichert',
    noSettings: 'Keine Einstellungen gefunden.',
    noChanges: 'Keine Änderungen zum Speichern.',
    saveError: 'Einige Einstellungen konnten nicht gespeichert werden.',
    settingCount: {
      one: 'Einstellung',
      other: 'Einstellungen',
    },
    categories: {
      API: 'API-Schlüssel',
      PROXY: 'Proxy',
      CRAWLER: 'Crawler',
      GENERAL: 'Allgemein',
      LOGGING: 'Protokollierung',
      EMAIL: 'E-Mail',
      SEO: 'SEO',
      SEA: 'SEA',
      MARKETING: 'Marketing',
    },
    source: {
      database: 'Datenbank',
      environment: 'Umgebung',
      default: 'Standard',
      none: 'Nicht gesetzt',
    },
  },
  profile: {
    title: 'Profil',
    username: 'Benutzername',
    email: 'E-Mail',
    role: 'Rolle',
    changePassword: 'Passwort ändern',
    currentPassword: 'Aktuelles Passwort',
    newPassword: 'Neues Passwort',
    confirmPassword: 'Passwort bestätigen',
    updateProfile: 'Profil aktualisieren',
    updated: 'Profil erfolgreich aktualisiert',
    details: 'Profildetails',
    name: 'Name',
    updateError: 'Profil konnte nicht aktualisiert werden.',
    passwordChanged: 'Passwort erfolgreich geändert.',
    passwordError: 'Passwort konnte nicht geändert werden.',
  },
  aiAdvisor: {
    title: 'KI-Berater',
    askQuestion: 'Stellen Sie eine Frage...',
    suggestions: 'Vorschläge',
    seoTips: 'SEO-Tipps',
    campaignInsights: 'Kampagnen-Einblicke',
    contentIdeas: 'Content-Ideen',
    analyzing: 'Analysiere...',
    unavailable: 'Der KI-Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es erneut.',
  },
  logs: {
    title: 'Systemprotokolle',
    container: 'Container',
    level: 'Level',
    message: 'Nachricht',
    timestamp: 'Zeitstempel',
    allContainers: 'Alle Container',
    allLevels: 'Alle Level',
    liveStream: 'Live-Stream',
    refresh: 'Aktualisieren',
    noLogs: 'Keine Protokolleinträge verfügbar.',
  },
  auth: {
    login: {
      title: 'Anmelden',
      subtitle: 'Melden Sie sich bei Ihrem Agentic SEO Konto an',
      credentials: 'Anmeldedaten',
      username: 'Benutzername',
      email: 'Benutzername oder E-Mail',
      password: 'Passwort',
      submit: 'Anmelden',
      noAccount: 'Kein Konto? Kontaktieren Sie Ihren Administrator für eine Einladung.',
      apiKeyLogin: 'Mit API-Schlüssel anmelden',
      apiKey: 'API-Schlüssel',
      apiKeyLabel: 'Ihr API-Schlüssel',
      error: 'Ungültige Anmeldedaten. Bitte versuchen Sie es erneut.',
    },
    register: {
      inviteOnlyTitle: 'Zugang nur auf Einladung',
      inviteOnlyDescription: 'Die Kontoerstellung wird von Ihrem Administrator verwaltet. Bitte kontaktieren Sie ihn, um einen Einladungslink zu erhalten.',
      backToLogin: 'Zurück zur Anmeldung',
    },
  },
  common: {
    loading: 'Laden...',
    error: 'Fehler',
    retry: 'Erneut versuchen',
    loadFailed: 'Daten konnten nicht geladen werden',
    success: 'Erfolg',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    search: 'Suchen...',
    filter: 'Filtern',
    export: 'Exportieren',
    import: 'Importieren',
    refresh: 'Aktualisieren',
    noData: 'Keine Daten verfügbar',
    confirm: 'Sind Sie sicher?',
    yes: 'Ja',
    no: 'Nein',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    pending: 'Ausstehend',
    completed: 'Abgeschlossen',
    failed: 'Fehlgeschlagen',
    running: 'Läuft',
    paused: 'Pausiert',
    total: 'Gesamt',
    actions: 'Aktionen',
    name: 'Name',
    description: 'Beschreibung',
    status: 'Status',
    date: 'Datum',
    createdAt: 'Erstellt',
    updatedAt: 'Aktualisiert',
    back: 'Zurück',
    next: 'Weiter',
    previous: 'Zurück',
    page: 'Seite',
    of: 'von',
    showing: 'Zeige',
    results: 'Ergebnisse',
    addUrl: 'URL hinzufügen',
    goBack: 'Zurück',
    backToProjects: 'Zurück zu Projekten',
    creating: 'Erstellen...',
    saving: 'Speichern...',
    copy: 'Kopieren',
    today: 'Heute',
    yesterday: 'Gestern',
    comingSoon: 'Demnächst verfügbar',
    comingSoonDescription: 'Diese Funktion befindet sich in Entwicklung und wird bald verfügbar sein.',
    exportCsv: 'CSV exportieren',
    exportPdf: 'Als PDF exportieren',
    exporting: 'Wird exportiert...',
  },
  projects: {
    title: 'Projekte',
    subtitle: 'Verwalten Sie Ihre SEO & Marketing Projekte',
    newProject: 'Neues Projekt',
    createFirst: 'Erstellen Sie Ihr erstes Projekt',
    backToProjects: 'Zurück zu Projekten',
    empty: {
      title: 'Noch keine Projekte',
      description: 'Erstellen Sie Ihr erstes Projekt, um SEO-Performance zu tracken, Kampagnen zu verwalten und Ihre Marketing-Tools zu verbinden.',
    },
    wizard: {
      title: 'Neues Projekt erstellen',
      description: 'Konfigurieren Sie Ihre Projekteinstellungen, Wettbewerber und Datenquellen.',
      projectName: 'Projektname',
      projectNamePlaceholder: 'z.B. US-Markt Expansion',
      websiteUrl: 'Website-URL',
      language: 'Primärer Markt / Sprache',
      selectLanguage: 'Sprache auswählen',
      languageHint: 'Diese Einstellung beeinflusst Keyword-Tracking und lokale SEO-Analyse.',
      location: 'Zielland',
      selectLocation: 'Land auswählen',
      urlStructure: 'URL-Struktur',
      singleLanguage: 'Einzelsprache',
      subdirectory: 'Unterverzeichnis (z.B. /de/, /en/)',
      subdomain: 'Subdomain (z.B. de.example.com)',
      crawlScope: 'Crawl-Bereich',
      crawlScopeHint: 'Nur URLs, die diesem Muster entsprechen, werden gecrawlt.',
      competitors: 'Wettbewerber-Websites',
      competitorUrl: 'Wettbewerber-URL',
      competitorsHint: 'Wir analysieren diese Seiten auf ihre Struktur, Keywords und Strategien.',
      discover: 'Auto-Entdecken',
      discoverCostHint: 'Auto-Entdecken nutzt die kostenpflichtige DataForSEO-Labs-API — jede Suche verbraucht Credits von Ihrem DataForSEO-Konto.',
      paidProvider: 'Kostenpflichtige DataForSEO-API',
      discoverError: 'Wettbewerber konnten nicht ermittelt werden. Versuchen Sie, diese manuell hinzuzufügen.',
      discoverEmpty: 'Es konnten keine Wettbewerber automatisch ermittelt werden. Konfigurieren Sie den SEO-Datenanbieter oder fügen Sie Wettbewerber manuell hinzu.',
      addUrlPlaceholder: 'Wettbewerber-URL hinzufügen',
      editCompetitor: 'Wettbewerber bearbeiten',
      saveCompetitor: 'Wettbewerber speichern',
      suggestedCompetitors: 'Vorgeschlagene Wettbewerber',
      integrationsHint: 'Wählen Sie die Datenquellen aus, die Sie verbinden möchten. Sie können diese später in den Projekteinstellungen konfigurieren.',
      createProject: 'Projekt erstellen',
      step3: {
        noConnections: 'Noch keine Konten verbunden',
        noConnectionsHint: 'Sie können Datenquellen später in den Projekteinstellungen verbinden.',
        goToIntegrations: 'Zu Integrationen',
        connectedAs: 'Verbunden als',
        selectProperty: 'Eigenschaft auswählen (optional)',
        optional: 'optional',
      },
    },
  },
  missionControl: {
    title: 'Mission Control',
    subtitle: 'Überblick über Ihre Projektleistung und anstehende Aufgaben',
    organicTraffic: 'Organischer Traffic',
    paidTraffic: 'Bezahlter Traffic',
    conversions: 'Conversions',
    seoScore: 'SEO Score',
    tasks: 'Prioritätsaufgaben',
    tasksDescription: 'KI-empfohlene Aktionen zur Leistungsverbesserung',
    integrations: 'Datenquellen',
    integrationsDescription: 'Verbundene Plattformen und ihr Sync-Status',
    noIntegrations: 'Noch keine Integrationen verbunden.',
    alertTitle: 'Aktion erforderlich',
    setupAlert: 'Vervollständigen Sie Ihr Projekt-Setup durch Verbinden von Datenquellen.',
    warningAlert: 'Einige Metriken erfordern Aufmerksamkeit. Prüfen Sie die folgenden Probleme.',
    trafficOverview: 'Traffic-Übersicht',
    seoHealth: 'SEO-Zustand',
    campaignPerformance: 'Kampagnenleistung',
    aiRecommendations: 'KI-Empfehlungen',
    recentActivity: 'Letzte Aktivität',
    notConnected: 'Nicht verbunden',
    connect: 'Verbinden',
    viewDetails: 'Details anzeigen',
    clicks: 'Klicks',
    impressions: 'Impressionen',
  },
  globalAI: {
    title: 'Globaler KI-Assistent',
    subtitle: 'Projektübergreifende Einblicke und strategische Empfehlungen',
    projectsConnected: 'Projekte verbunden',
    welcome: 'Wie kann ich Ihnen heute helfen?',
    welcomeDescription: 'Fragen Sie mich alles über Ihre SEO-, Werbe- oder Marketingstrategie über alle Ihre Projekte hinweg.',
    placeholder: 'Fragen Sie zu Ihrer SEO, Werbung oder Marketingstrategie...',
    hint: 'Drücken Sie Enter zum Senden, Shift+Enter für neue Zeile',
    unavailable: 'Der KI-Dienst ist derzeit nicht verfügbar. Bitte versuchen Sie es erneut.',
  },
  oauth: {
    connecting: 'Verbinden...',
    success: 'Verbunden!',
    failed: 'Verbindung fehlgeschlagen',
    processingMessage: 'Bitte warten Sie, während wir die Autorisierung abschließen...',
    successMessage: 'Ihr Konto wurde erfolgreich verbunden. Weiterleitung...',
    genericError: 'Verbindung zum Konto fehlgeschlagen',
    tryAgain: 'Bitte versuchen Sie es erneut oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht.',
    missingParams: 'Fehlender Autorisierungscode oder State-Parameter',
    notAuthenticated: 'Sie müssen angemeldet sein, um Integrationen zu verbinden',
    unexpectedError: 'Ein unerwarteter Fehler ist aufgetreten',
  },
  feedback: {
    title: 'Feedback senden',
    type: 'Feedback-Typ',
    bugReport: 'Fehlerbericht',
    featureRequest: 'Funktionswunsch',
    improvement: 'Verbesserung',
    question: 'Frage',
    titleField: 'Titel',
    titlePlaceholder: 'Kurze Zusammenfassung...',
    description: 'Beschreibung',
    descriptionPlaceholder: 'Erzählen Sie uns mehr...',
    attachment: 'Anhang',
    submit: 'Feedback absenden',
    success: 'Vielen Dank für Ihr Feedback!',
    close: 'Schließen',
  },
  abTesting: {
    title: 'A/B-Tests',
    newTest: 'Neuer Test',
    variants: 'Varianten',
    trafficSplit: 'Traffic-Aufteilung',
    winner: 'Gewinner',
    confidence: 'Konfidenz',
    adCopy: 'Anzeigentext-Test',
    landingPage: 'Landing-Page-Test',
    content: 'Inhaltstest',
    declareWinner: 'Gewinner erklären',
    significanceReached: 'Statistische Signifikanz erreicht (95%+ Schwelle)',
    noTests: 'Noch keine A/B-Tests. Erstellen Sie Ihren ersten Test.',
    awaitingData: 'Daten werden gesammelt...',
  },
  workflowHistory: {
    title: 'Ausführungsverlauf',
    workflow: 'Workflow',
    started: 'Gestartet',
    duration: 'Dauer',
    triggeredBy: 'Ausgelöst von',
    rerun: 'Erneut ausführen',
    viewLogs: 'Logs anzeigen',
    noExecutions: 'Noch keine Workflow-Ausführungen.',
  },
  roadmap: {
    title: 'Produkt-Roadmap',
    subtitle: 'Sehen Sie, was wir bauen und was als Nächstes kommt',
    requestFeature: 'Feature anfragen',
    boardView: 'Board',
    timelineView: 'Timeline',
    planned: 'Geplant',
    inprogress: 'In Arbeit',
    completed: 'Abgeschlossen',
    underreview: 'Wird geprüft',
    items: {
      seoAudit: 'Umfassende Crawling-, Bewertungs- und Empfehlungsengine',
      googleAds: 'Direkte Google Ads API-Integration für Kampagnenverwaltung',
      aiConnector: 'Einheitlicher KI-Connector für Claude-, Gemini- und OpenAI-Integrationen',
      reporting: 'Geplante PDF-/E-Mail-Berichte mit benutzerdefinierten Vorlagen',
      multiLang: 'Unterstützung für mehrsprachige SEO-Analyse und hreflang-Verwaltung',
      budgetOptimizer: 'KI-gesteuerte Budgetverteilung über Kampagnen',
      competitorIntel: 'Tiefgehende Wettbewerbsanalyse mit automatisierten Erkenntnissen',
      workflowBuilder: 'Visuelles Drag-and-Drop-Workflow-Erstellungstool',
      socialMedia: 'Social-Media-Inhalte über alle wichtigen Plattformen veröffentlichen, planen und verfolgen',
    },
  },
  admin: {
    totalUsers: 'Benutzer gesamt',
    createUser: 'Benutzer erstellen',
    autoPassword: 'Ein sicheres Passwort wird automatisch generiert.',
    resetPassword: 'Passwort zurücksetzen',
    applyPassword: 'Passwort anwenden',
    role: 'Rolle',
    userCreated: 'Benutzer erfolgreich erstellt',
    userCreatedPassword: 'Generiertes Passwort (jetzt kopieren — wird nur einmal angezeigt):',
    userCreateError: 'Benutzer konnte nicht erstellt werden.',
    usersLoadError: 'Benutzer konnten nicht geladen werden.',
    roleChanged: 'Rolle erfolgreich aktualisiert',
    roleChangeError: 'Rolle konnte nicht aktualisiert werden.',
    passwordGenerateError: 'Sicheres Passwort konnte nicht generiert werden.',
    passwordReset: 'Passwort erfolgreich zurückgesetzt',
    passwordResetError: 'Passwort konnte nicht zurückgesetzt werden.',
    userDeleted: 'Benutzer erfolgreich gelöscht',
    userDeleteError: 'Benutzer konnte nicht gelöscht werden.',
    deleteUserTitle: 'Benutzer löschen?',
    deleteUserDescription: 'Dies entfernt {{name}} dauerhaft und alle zugehörigen Daten.',
  },
  templates: {
    title: 'Vorlagen',
    subtitle: 'Wiederverwendbare Inhaltsvorlagen mit dynamischen Variablen verwalten',
    projectSubtitle: 'Vorlagen für dieses Projekt',
    create: 'Vorlage erstellen',
    namePlaceholder: 'Vorlagenname...',
    contentPlaceholder: 'Schreiben Sie hier Ihren Vorlageninhalt. Verwenden Sie Variablen wie {{project_name}} für dynamische Werte...',
    insertVariable: 'Variable einfügen',
    editor: 'Editor',
    preview: 'Vorschau',
    emptyPreview: 'Vorschau wird hier angezeigt...',
    variables: 'Variablen',
    empty: 'Noch keine Vorlagen. Erstellen Sie Ihre erste Vorlage.',
    global: 'Global',
    typeEmail: 'E-Mail',
    typeReport: 'Bericht',
    typeNotification: 'Benachrichtigung',
    typeSEOBrief: 'SEO-Brief',
  },
  integrations: {
    title: 'Integrationen',
    subtitle: 'Verbinden Sie Ihre Konten und verwalten Sie API-Schlüssel',
    oauthSection: 'OAuth-Verbindungen',
    oauthDescription: 'Verknüpfen Sie Ihre Konten, um die Datensynchronisierung für alle Projekte zu aktivieren',
    apiKeySection: 'API-Schlüssel-Integrationen',
    apiKeyDescription: 'Fügen Sie API-Schlüssel für SEO-Tools und Datenanbieter hinzu',
    connect: 'Verbinden',
    disconnect: 'Trennen',
    refresh: 'Tokens aktualisieren',
    addApiKey: 'API-Schlüssel hinzufügen',
    removeApiKey: 'Entfernen',
    connected: 'Verbunden',
    disconnected: 'Nicht verbunden',
    expired: 'Abgelaufen',
    error: 'Fehler',
    connectedAs: 'Verbunden als',
    connectedSince: 'Verbunden seit',
    lastRefreshed: 'Zuletzt aktualisiert',
    confirmDisconnect: 'Sind Sie sicher? Dies entfernt alle Projektintegrationen, die diese Verbindung nutzen.',
    apiKeyLabel: 'Bezeichnung (optional)',
    apiKeyPlaceholder: 'API-Schlüssel eingeben',
    apiSecretPlaceholder: 'API-Geheimnis eingeben (falls erforderlich)',
    provider: 'Anbieter',
    infoText: 'Verbinden Sie hier Ihre Konten. Nach der Verbindung können Sie einzelne Properties in den Projekteinstellungen zuweisen.',
    adminOnly: 'Nur Administratoren können Verbindungen verwalten',
    credentialsNotConfigured: 'OAuth-Anmeldedaten sind nicht konfiguriert. Klappen Sie die Anbieter-Karte auf und fügen Sie Client-ID & Secret hinzu.',
    credentialsHintTitle: 'OAuth-Anmeldedaten zuerst konfigurieren',
    credentialsHintDescription: 'Bevor Sie Konten verbinden, klappen Sie die Anbieter-Karte unten auf und geben Sie Ihre OAuth Client-ID & Secret ein.',
    connectError: 'Verbindung konnte nicht initiiert werden',
    connectAnother: 'Weiteres Konto verbinden',
    noConnections: 'Noch keine Konten verbunden',
    noApiKey: 'Noch kein API-Schlüssel konfiguriert',
    lastVerified: 'Zuletzt geprüft',
    test: 'Testen',
    testConnection: 'Verbindung testen',
    remove: 'Entfernen',
    // OAuth App Configuration
    oauthConfig: 'OAuth-App-Konfiguration',
    oauthConfigDesc: 'Konfigurieren Sie OAuth-Anmeldedaten für jeden Anbieter. Sie können die plattformbereitgestellten Standardwerte verwenden oder eigene App-Anmeldedaten eingeben.',
    redirectUri: 'Redirect-URI',
    redirectUriHint: 'Fügen Sie diese Redirect-URI in Ihrer OAuth-App-Konfiguration in der Entwicklerkonsole des Anbieters hinzu.',
    copyUrl: 'Kopieren',
    urlCopied: 'In Zwischenablage kopiert',
    credentialStatus: 'Anmeldedaten-Status',
    configured: 'Konfiguriert',
    notConfigured: 'Nicht konfiguriert',
    sourceEnvironment: 'Plattform',
    sourceDatabase: 'Benutzerdefiniert',
    configureProvider: 'Konfigurieren',
    clientId: 'Client-ID',
    clientSecret: 'Client-Secret',
    saveCredentials: 'Anmeldedaten speichern',
    savingCredentials: 'Speichern…',
    credentialsSaved: 'Anmeldedaten erfolgreich gespeichert',
    credentialsSaveError: 'Fehler beim Speichern der Anmeldedaten',
    showConfig: 'Konfiguration anzeigen',
    hideConfig: 'Konfiguration ausblenden',
  },
  projectSettings: {
    title: 'Projekteinstellungen',
    tabs: {
      general: 'Allgemein',
      settings: 'Einstellungen',
      dataSources: 'Datenquellen',
      connectors: 'Connectoren',
      competitors: 'Wettbewerber',
      sea: 'SEA',
    },
    sea: {
      title: 'SEA-Einstellungen',
      subtitle: 'Zentrale Google-Ads-Konfiguration, die von allen Kampagnen dieses Projekts verwendet wird',
      googleAdsCustomerId: 'Google-Ads-Kundennummer',
      customerIdHint: 'Kundennummer muss exakt 10 Ziffern haben',
      globalValue: 'Global',
      save: 'Speichern',
      saved: 'Google-Ads-Kundennummer gespeichert',
      resetButton: 'Auf global zurücksetzen',
      reset: 'Überschreibung entfernt — globaler Wert wird verwendet',
      loadError: 'SEA-Einstellungen konnten nicht geladen werden',
      saveError: 'Kundennummer konnte nicht gespeichert werden',
      overrideActive: 'Eine projektspezifische Google-Ads-Kundennummer ist für dieses Projekt aktiv.',
      customerIdDesc: '10-stellige Google-Ads-Kontonummer. Leer lassen, um den globalen Wert zu verwenden.',
    },
    settings: {
      title: 'Projekteinstellungen',
      description: 'Globale Einstellungen für dieses Projekt überschreiben. Werte werden von den globalen Einstellungen übernommen, sofern nicht überschrieben.',
      categoryHint: 'Projektüberschreibungen für diese Kategorie. Leer lassen, um den globalen Wert zu übernehmen.',
      reset: 'Auf global zurücksetzen',
      globalValue: 'Global',
    },
    settingsSaved: 'Einstellungen gespeichert',
    settingsReset: 'Auf global zurückgesetzt',
    source: {
      project: 'Projekt-Überschreibung',
      database: 'Datenbank',
      environment: 'Umgebung',
      default: 'Standard',
      none: 'Keine',
    },
    general: {
      name: 'Projektname',
      url: 'Website-URL',
      language: 'Sprache',
      save: 'Änderungen speichern',
      saved: 'Projekt erfolgreich aktualisiert',
    },
    dataSources: {
      title: 'Datenquellen',
      description: 'Verbinden Sie Ihre Analyse- und Werbekonten mit diesem Projekt.',
      connectFirst: '{{provider}} zuerst auf der Integrationsseite verbinden',
      goToIntegrations: 'Zu Integrationen',
      selectProperty: 'Eigenschaft auswählen...',
      configure: 'Speichern',
      disconnect: 'Trennen',
      connected: 'Verbunden',
      configuring: 'Speichern...',
      noProperties: 'Keine Eigenschaften für dieses Konto gefunden',
      tokenExpired: 'Token abgelaufen — bitte Verbindung aktualisieren',
      manage: 'Datenquellen verwalten',
      adsDeveloperToken: 'Google Ads Developer Token (Projekt-Override)',
      adsDeveloperTokenPlaceholder: 'Projekt-eigener Developer Token (optional)',
      adsOverrideSave: 'Speichern',
      adsOverrideHint: 'Optional: überschreibt den globalen Google-Ads-Developer-Token für dieses Projekt. Leer lassen zum Löschen des Overrides.',
      adsOverrideError: 'Override konnte nicht gespeichert werden',
    },
    competitors: {
      title: 'Wettbewerber',
      description: 'Fügen Sie Wettbewerber-Websites hinzu, um sie zu verfolgen und zu vergleichen.',
      addCompetitor: 'Wettbewerber hinzufügen',
      urlPlaceholder: 'https://wettbewerber.de',
      remove: 'Entfernen',
      empty: 'Noch keine Wettbewerber hinzugefügt',
    },
    connectors: {
      title: 'Connectoren',
      description: 'Aktivieren oder deaktivieren Sie Connectoren für dieses Projekt. Deaktivierte Connectoren werden nicht verwendet.',
      enabled: 'Aktiviert',
      disabled: 'Deaktiviert',
      enable: 'Aktivieren',
      disable: 'Deaktivieren',
      reset: 'Auf globalen Standard zurücksetzen',
      overridden: 'Projektüberschreibung',
      inheritsGlobal: 'Übernimmt globale Einstellung',
      empty: 'Noch keine Connectoren verfügbar. Verbinden Sie zuerst Integrationen und aktivieren Sie Connectoren global (Integrationen → Connectoren).',
    },
  },
  connectors: {
    title: 'Connectoren',
    description: 'Verwaltung verfügbarer Connector-Typen. Hier aktivierte Connectoren stehen allen Projekten zur Verfügung.',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    enable: 'Aktivieren',
    disable: 'Deaktivieren',
    save: 'Speichern',
    saved: 'Connector aktualisiert',
    category: {
      seo: 'SEO',
      analytics: 'Analytics',
      sea: 'Werbung',
      social: 'Social Media',
      other: 'Sonstige',
    },
    authType: {
      oauth: 'OAuth',
      api_key: 'API-Schlüssel',
      none: 'Keine',
    },
    globallyDisabled: 'Global deaktiviert',
    notAvailable: 'Nicht verfügbar',
    notAvailableHint: 'Verbinden Sie zuerst die Integration, um diesen Connector zu aktivieren.',
    noConnectors: 'Keine Connector-Definitionen gefunden. Bitte Backend-Seed überprüfen.',
  },
  // AI Copilot Seite
  aiCopilot: {
    title: 'KI Copilot',
    subtitle: 'Ihr intelligenter Assistent für Marketing-Aufgaben',
    welcome: 'Wie kann ich Ihnen helfen?',
    welcomeDescription: 'Fragen Sie mich alles zu SEO, Anzeigen oder Marketing-Strategie für dieses Projekt.',
    placeholder: 'Fragen Sie zu SEO, Anzeigen oder Marketing-Strategie...',
  },
  // Workflows Seite
  workflows: {
    title: 'Workflows',
    subtitle: 'Automatisieren Sie Ihre Marketing-Aufgaben mit Workflows',
    create: 'Workflow erstellen',
    templates: 'Workflow-Vorlagen',
    useTemplate: 'Vorlage nutzen',
    steps: 'Schritte',
    emptyTitle: 'Noch keine Workflows',
    emptyDesc: 'Erstellen Sie Ihren ersten Workflow, um Marketing-Aufgaben zu automatisieren',
  },
  // Social Seite
  social: {
    title: 'Social Media',
    subtitle: 'Verwalten Sie Ihre Social-Media-Präsenz und planen Sie Posts',
    createPost: 'Post erstellen',
    totalFollowers: 'Follower gesamt',
    avgEngagement: 'Engagement Ø',
    scheduledPosts: 'Geplante Posts',
    connectedPlatforms: 'Verbundene Plattformen',
    upcomingPosts: 'Bevorstehende Posts',
  },
  // Ads Dashboard Seite
  adsDashboard: {
    title: 'Ads Dashboard',
    subtitle: 'Überwachen und optimieren Sie Ihre Werbekampagnen',
    createCampaign: 'Kampagne erstellen',
    totalSpend: 'Gesamtausgaben',
    totalClicks: 'Klicks gesamt',
    conversions: 'Conversions',
    roas: 'ROAS',
    campaigns: 'Aktive Kampagnen',
    campaignName: 'Kampagne',
    platform: 'Plattform',
    budget: 'Budget',
    spend: 'Ausgaben',
    impressions: 'Impressionen',
    clicks: 'Klicks',
    totalImpressions: 'Impressionen gesamt',
    campaignCount: 'Kampagnen',
    noCampaigns: 'Noch keine Kampagnen — Google Ads verbinden und Sync ausführen.',
    detailHint: 'Details in Performance',
  },
  seoSchedules: {
    title: 'SEO-Zeitpläne',
    subtitle: 'Alle automatisierten Checks für dieses Projekt verwalten',
    crawlSection: 'Crawl-Zeitpläne',
    crawlSectionDesc: 'Automatische Website-Crawls — startet die SEO-Audit-Pipeline',
    serpSection: 'SERP-Check-Konfigurationen',
    serpSectionDesc: 'Benannte Keyword-Check-Sets mit Gerät, Ort und Zeitplan',
    keywordSection: 'Keyword-Check-Zeitpläne',
    keywordSectionDesc: 'Geplante automatische Keyword-Ranking-Checks',
    backlinkSection: 'Backlink-Zeitpläne',
    backlinkSectionDesc: 'Geplante Backlink-Prüfungen — Master + je Wettbewerber',
    noSchedule: 'Kein Zeitplan gesetzt',
    nextRun: 'Nächster Lauf',
    lastRun: 'Letzter Lauf',
    nextRunLabel: 'nächster',
    lastRunLabel: 'letzter',
    manageSchedules: 'Zeitpläne verwalten',
    setUpSchedule: 'Einrichten',
    configsActive: 'aktive Konfigurationen',
    addCrawlSchedule: 'Neuer Crawl-Zeitplan',
    addBacklinkSchedule: 'Zeitplan hinzufügen',
    addKeywordSchedule: 'Keyword-Zeitplan hinzufügen',
    newConfig: 'Neue Konfiguration',
    masterDomain: 'Ihre Domain',
    competitorLabel: 'Wettbewerber',
    runNow: 'Jetzt ausführen',
    editSchedule: 'Bearbeiten',
    noCompetitors: 'Keine Wettbewerber für dieses Projekt konfiguriert.',
    statusChipManage: '→ Verwalten',
    lastRuns: 'Letzte Läufe',
    noRunHistory: 'Kein Ausführungsverlauf',
  },

  // Phase B-D feature namespaces
  keywordMap: {
    title: 'Keyword-Mapping',
    subtitle: 'Keywords Seiten zuordnen und Kannibalisierung erkennen.',
    runAlgo: 'Algorithmus ausführen',
    runAi: 'KI-Analyse starten',
    noMaps: 'Noch keine Keyword-Maps.',
  },
  keywordResearch: {
    title: 'Keyword-Recherche',
    subtitle: 'Keyword-Möglichkeiten entdecken und analysieren.',
    query: 'Keywords suchen…',
    noResults: 'Keine Ergebnisse gefunden.',
  },
  contentOptimization: {
    title: 'Content-Optimierung',
    subtitle: 'KI-gestützte Verbesserungsvorschläge für Inhalte.',
    accept: 'Akzeptieren',
    dismiss: 'Ablehnen',
    noSuggestions: 'Noch keine Vorschläge.',
    workbench: 'Workbench',
    generateBrief: 'Brief generieren',
    generatingBrief: 'Brief wird generiert…',
    briefGenerated: 'Brief erfolgreich generiert',
    focusKeyword: 'Focus-Keyword',
    secondaryKeywords: 'Sekundäre Keywords',
    scoreBefore: 'Score vorher',
    scoreAfter: 'Score nachher',
    geoAeoScore: 'GEO/AEO-Score',
    recalculate: 'Neu berechnen',
    acceptSection: 'Abschnitt übernehmen',
    rejectSection: 'Ablehnen',
    regenerate: 'Neu generieren',
    verifyFlags: 'Prüfpunkte',
    schemaPreview: 'Schema-Vorschau',
    newPreset: 'Neues Preset',
    builtinPreset: 'Integriert',
    editPreset: 'Preset bearbeiten',
    deletePreset: 'Preset löschen',
    pageType: 'Seitentyp',
    minWords: 'Min. Wörter',
    opportunities: 'Content-Möglichkeiten',
    presets: 'Presets',
    tier1: 'Quick Wins',
    tier2: 'Hohes Potenzial',
    tier3: 'Handlungsbedarf',
    tier4: 'Niedrige Priorität',
    opportunityScore: 'Opportunity-Score',
    noOpportunities: 'Keine Optimierungsmöglichkeiten gefunden.',
    createProject: 'Projekt erstellen',
    all: 'Alle',
    projects: 'Meine Projekte',
    noProjects: 'Noch keine Optimierungsprojekte.',
    backToOpportunities: '← Möglichkeiten',
    openProject: 'Projekt öffnen',
    viewAllProjects: 'Alle Projekte anzeigen',
    costNoticeLabel: 'KI-Verarbeitung:',
    costNotice: 'Verwendet Ihren konfigurierten KI-Anbieter — Kosten werden über Ihren API-Schlüssel abgerechnet.',
    dataforseoPaidBadge: 'Kostenpflichtige DataForSEO-API',
    loadingKeywordMetrics: 'Keyword-Metriken werden geladen…',
    dataforseoConsentTitle: 'Kostenpflichtige DataForSEO-Analyse aktivieren?',
    dataforseoConsentBody: 'SERP-Wettbewerbsanalyse und Keyword-Metriken nutzen die kostenpflichtige DataForSEO-API. Jede Abfrage verbraucht Credits Ihres DataForSEO-Kontos. Kosten werden im API-Ausgaben-Dashboard erfasst.',
    dataforseoConsentAccept: 'Aktivieren & fortfahren',
    dataforseoConsentDecline: 'Jetzt nicht',
    dataforseoConsentHint: 'DataForSEO für Wettbewerbs-Keywords & Keyword-Metriken aktivieren.',
    urlKeywords: 'URL-Keywords',
    suggestedKeywords: 'Vorgeschlagen aus URL',
    briefReady: 'Brief ist fertig!',
    briefPending: 'Brief wird generiert…',
    briefTimeout: 'Brief-Generierung dauert lange. Aktualisieren, um Status zu prüfen.',
    saveKeywords: 'Keywords speichern',
    backToProjects: '← Meine Projekte',
    generateOutline: 'Outline generieren',
    runPipeline: 'Optimierungs-Loop starten',
    runIteration: 'Eine Iteration ausführen',
    finalize: 'Finalisieren',
    publishReady: 'Veröffentlichungsreif',
    publishNotReady: 'Noch Optimierungsbedarf',
    iterationHistory: 'Iterationsverlauf',
    contentSourceScraped: 'Optimiert bestehenden (gecrawlten) Inhalt',
    contentSourceScratch: 'Neuer Inhalt — von Grund auf geschrieben',
    keywordsFromMap: 'aus Keyword-Mapping',
    tertiaryKeywords: 'Tertiäre Keywords',
    feedback: 'Feedback',
    scoreDelta: 'Score-Differenz',
    maxIterations: 'Max. Iterationen',
    noIterations: 'Noch keine Iterationen — Loop starten, um Fortschritt zu sehen.',
    pipelineQueued: 'Pipeline gestartet — Outline → Entwurf → Loop → Finalisierung.',
    iterationQueued: 'Eine Iteration gestartet.',
    finalizeQueued: 'Finalisierung gestartet.',
    recontextQueued: 'Kontext-Neuaufbau gestartet.',
    loopScore: 'Gesamtscore',
    exportTitle: 'Exportieren',
    copyHtml: 'HTML kopieren',
    copyText: 'Text kopieren',
    copied: 'Kopiert!',
    downloadReport: 'Bericht',
    downloadContent: 'Inhalt',
    downloadPdf: 'PDF herunterladen',
    optimizationTerms: 'Optimierungsbegriffe',
    termsMet: '{{met}}/{{total}} erreicht',
    termsHint: 'Ziel = von Mitbewerbern abgeleitetes Vorkommensziel. Grün = erreicht.',
    fromSerp: 'SERP',
    similarity: 'Ähnlichkeit',
    similarityVsExisting: 'vs. bestehende Seite',
    similaritySeoImprovement: 'SEO-Verbesserung',
    similarityTooSimilar: 'Zu ähnlich zur bestehenden Seite — stärkere Überarbeitung erwägen.',
    keywordsTitle: 'Keywords',
    outlineTitle: 'Gliederung',
    serpAnalysisTitle: 'SERP-Analyse',
    aiWriting: 'KI-Schreiben',
    scoreTitle: 'Score',
    edit: 'Bearbeiten',
    refresh: 'Aktualisieren',
    defineKeywordsFirst: 'Zuerst Keywords definieren',
    researchingSerp: 'Wettbewerber werden recherchiert…',
  },
  urlHygiene: {
    title: 'URL-Hygiene',
    issues: 'Probleme',
    noIssues: 'Keine URL-Hygiene-Probleme.',
  },
  migration: {
    title: 'Migration / Vergleich',
    subtitle: 'Alte URLs neuen zuordnen und strukturelle Änderungen vergleichen.',
    create: 'Migration erstellen',
    runMatch: 'URL-Abgleich starten',
    runCompare: 'Vergleich starten',
    noMigrations: 'Noch keine Migrationen.',
  },
  tasks: {
    title: 'Smarte To-Do-Liste',
    subtitle: 'Nach rechts wischen = erledigen, links = verschieben, hoch = terminieren.',
    generate: 'KI-Aufgaben generieren',
    generateGeo: 'GEO Best Practices',
    geoGenerated: '{{n}} GEO-Best-Practice-Aufgaben hinzugefügt.',
    geoGeneratedNone: 'GEO-Best-Practice-Aufgaben existieren bereits.',
    generated: 'KI-Aufgaben generiert',
    generatedQueued: 'Aufgabengenerierung in Warteschlange — Aufgaben erscheinen in Kürze.',
    costHint: 'Die KI-Aufgabengenerierung nutzt deinen konfigurierten KI-Anbieter und wird über deinen API-Schlüssel abgerechnet. Sie läuft im Hintergrund — Aufgaben erscheinen, sobald sie fertig sind.',
    noTasks: 'Noch keine Aufgaben.',
    open: 'Offen',
    inProgress: 'In Bearbeitung',
    done: 'Erledigt',
  },
  geo: {
    title: 'GEO — Generative Engine Optimization',
    subtitle: 'LLM-Erwähnungen und KI-Sichtbarkeit überwachen.',
    refresh: 'Erwähnungen aktualisieren',
    noMentions: 'Noch keine LLM-Erwähnungen verfolgt.',
    checklist: 'Best-Practice-Checkliste',
    faqAudit: 'FAQ-Audit',
  },
  visualAnalysis: {
    title: 'Visuelle Analyse',
    subtitle: 'KI-gestützte UX- und SEO-Kritik anhand von Seiten-Screenshots.',
    analyze: 'Seitentypen analysieren',
    noAnalyses: 'Noch keine Analysen.',
    pageTypes: 'Seitentypen',
    results: 'Ergebnisse',
    hypotheses: 'Hypothesen',
    autoDetected: 'automatisch erkannt',
    competitorNotice: 'Wettbewerber: Top-3-SERP-Seiten (kostenpflichtig, DataForSEO, Zustimmung erforderlich)',
    visionFallbackToast: 'Das konfigurierte Modell unterstützt keine Bildanalyse — stattdessen wird eine Crawl-Daten-Analyse angezeigt.',
    queued: 'Analyse in Warteschlange — prüfe gleich den Reiter „Ergebnisse“.',
    analyzeError: 'Analyse konnte nicht eingereiht werden.',
    hypothesisStarted: 'Test gestartet — GA4-Basiswert erfasst.',
    hypothesisConcluded: 'Test abgeschlossen — Ergebnisse gemessen.',
    hypothesisMeasured: 'Ergebnisse aktualisiert.',
    hypothesisError: 'Aktion fehlgeschlagen.',
    requiresCompetitors: 'Wettbewerbsvergleich erfordert DataForSEO-Zustimmung + ein Haupt-Keyword.',
    requiresGa4: 'GA4 nicht verbunden — übersprungen.',
    requiresClarity: 'Clarity nicht verbunden — übersprungen.',
  },
  irysIndex: {
    title: 'Irys SEO Index',
    subtitle: 'Zusammengesetzter SEO-Gesundheitswert über 7 Dimensionen.',
    avg: 'Durchschnittswert',
    dimensions: 'Dimensionen',
    history: 'Score-Verlauf',
    weights: 'Dimensions-Gewichtung',
    overallScore: 'Gesamt',
    regenerate: 'Analysieren & Aufgaben generieren',
    regenerateQueued: 'Irys-Analyse in Warteschlange — Wettbewerbsvergleich, KI-Zusammenfassung und Smart-To-Do-Aufgaben werden generiert.',
    weightsSaved: 'Gewichtung gespeichert — gilt für den nächsten Scoring-Lauf.',
    costHint: '„Analysieren & Aufgaben generieren" führt die KI-Zusammenfassung + Smart-To-Do-Generierung aus (abgerechnet über deinen konfigurierten KI-Anbieter) und nutzt deine bereits gespeicherten SERP- + Wettbewerbsdaten — kein neuer kostenpflichtiger DataForSEO-Aufruf.',
  },
  spending: {
    title: 'API-Ausgaben',
    currentMonth: 'Aktueller Monat',
    provider: 'Anbieter',
    total: 'Gesamtkosten',
    noData: 'Keine Ausgabendaten.',
  },

  aiSettings: {
    title: 'KI & Modelle',
    subtitle: 'API-Schlüssel konfigurieren und KI-Modelle je Aufgabe wählen.',
    active: 'Aktiv',
    masterKeyNote: ' (Master-Key — alle Aufrufe laufen über OpenRouter)',
    masterKeyBadge: 'Master-Key',
    activeSummary: {
      openrouter: 'Alle KI-Aufrufe laufen über OpenRouter. Individuelle Provider-Keys werden ignoriert.',
    },
    openRouterMaster: 'OpenRouter-API-Key (Master)',
    openRouterWarning: '⚠ Wenn gesetzt, laufen ALLE KI-Aufrufe über OpenRouter. Andere Provider-Keys werden ignoriert.',
    individualProviderKeys: 'Individuelle Provider-Keys',
    providerKeys: 'Provider-API-Keys',
    individualProviderKeysHint: 'Füge einen Key für jeden Provider hinzu. Der zuletzt gespeicherte Key wird der aktive Provider.',
    disabledOpenRouter: '(deaktiviert — OpenRouter ist aktiv)',
    apiKeyPlaceholder: 'API-Key...',
    preferredProvider: 'Bevorzugter Provider:',
    defaultModelsPerTask: 'Standard-Modelle je Aufgabe',
    defaultModelsDescription: 'Wähle das Modell je KI-Funktion. Leer lassen, um das System-Preset (Claude) zu verwenden.',
    twoDropdownsHint: 'Wähle einen Provider und ein Modell je Berührungspunkt. Modelle werden live vom Provider geladen.',
    groups: {
      seo: 'SEO-Service',
      sea: 'SEA-/Ads-Service',
      automation: 'Automation & Reports',
    },
    groupHints: {
      seo: 'Berührungspunkte des seo-service',
      sea: 'Berührungspunkte des sea-service',
      automation: 'Berührungspunkte des automation-service',
    },
    selectProviderFirst: 'Zuerst einen Provider wählen',
    loadingModels: 'Modelle werden geladen…',
    noModels: 'Keine Modelle verfügbar',
    free: 'kostenlos',
    refreshModels: 'Modelle aktualisieren',
    testProvider: 'Verbindung testen',
    keySet: 'Schlüssel gesetzt',
    keySetHint: 'leer lassen, um ihn zu behalten — neuen eintippen, um zu ersetzen',
    systemPreset: 'System-Preset (Claude)',
    saveSettings: 'Einstellungen speichern',
    resetToDefaults: 'Auf Standard zurücksetzen',
    settingsSaved: 'Einstellungen gespeichert',
    saveFailed: 'Speichern fehlgeschlagen',
    resetDone: 'Auf Standard zurückgesetzt',
    resetFailed: 'Zurücksetzen fehlgeschlagen',
    taskLabels: {
      migrationMatch: 'URL-Migrationsabgleich',
      contentGeneration: 'Content-Generierung',
      contentOutline: 'Content-Outline-Generierung',
      contentCritique: 'Content-Review / Kritik',
      contentRewrite: 'Content-Umschreiben (Loop-Fix)',
      metaSuggest: 'Meta-Vorschläge',
      h1Suggest: 'H1-Vorschläge',
      keywordSuggest: 'Keyword-Vorschläge',
      seoTasksAi: 'SEO-Aufgabengenerierung',
      contentScore: 'Content-Scoring',
      visualAnalysis: 'Visuelle Analyse',
      irysScoring: 'Irys-SEO-Scoring',
      geoFaq: 'GEO-FAQ-Audit',
      geoChecklist: 'GEO-Checkliste',
      seaCampaignSuggest: 'SEA-Kampagnenvorschläge',
      seaAdCopy: 'SEA-Anzeigentexte',
      seaKeywordResearch: 'SEA-Keyword-Recherche',
      automationContent: 'Marketing-Content-Generierung',
      reportNarrative: 'Report-Narrative / Maßnahmen',
    },
    providerLabels: {
      openrouter: 'OpenRouter (Master-Key)',
      anthropic: 'Anthropic (Claude)',
      deepseek: 'DeepSeek',
      openai: 'OpenAI',
      google: 'Google (Gemini)',
    },
    providerDescriptions: {
      openrouter: 'Leitet alle KI-Aufrufe über ein Gateway mit Zugriff auf viele Modelle.',
      anthropic: 'Claude-Modelle — der Standard-Provider für die meisten SEO-Aufgaben.',
      deepseek: 'DeepSeek-Modelle für kostengünstige Generierung.',
      openai: 'OpenAI-GPT-Modelle.',
      google: 'Gemini-Modelle von Google.',
    },
  },
} as const;